import ky from "ky";
import { store, Unsubscribe } from "@stencil/redux";
import { forkJoin, Subject, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import {
  ConversationFactory,
  IContactInfo,
  IMessage,
  IMember,
  IConversation,
  IConversationEventHandlers,
  CXEnvironment,
  ChatModeEnum,
  CobrowseRequestType,
  ConversationTypeEnum,
} from "@auvious/integrations";
import { ISchedule } from "@auvious/utils";
import {
  Component,
  h,
  State,
  Prop,
  Method,
  Event,
  EventEmitter,
  Watch,
  Host,
  ComponentInterface,
  Element,
  forceUpdate,
} from "@stencil/core";

import { configureStore } from "../../store";
import {
  WindowEventService,
  ThemeService,
  windowActionType,
  LeaveCallAction,
  AppConfigService as Config,
  TranslateService,
  Log,
  ErrorHandler,
  DeviceService,
  ITranslationMap,
  CobrowseService,
  StorageService,
  ScreenShareAvailabilityChangedAction,
  HeartbeatService,
  ScheduleService,
  SecurityService,
  CallService,
  QueueService,
  CommonService,
  DigitalConnectAuthClient,
  AppConfigService,
} from "../../services";
import {
  ConversationStateEnum,
  RegistrationTypeEnum,
  WidgetsEnum,
  Action,
  CallStateEnum,
  DisplayCaptureStateEnum,
  PARAM_WIDGET_ORIGIN_URL,
  PARAM_CALL_TYPE,
  PARAM_KIOSK_MODE,
  PARAM_LANG,
  CobrowseStateEnum,
  CobrowseOriginEnum,
  PARAM_COBROWSE_AVAILABLE,
  KEY_VIDEO_POPOUT,
  KEY_CONVERSATION_REQUEST,
  ICustomField,
  KEY_CONVERSATION_TYPE,
  KEY_TIME_IN_QUEUE,
  PARAM_DISPLAY_NAME,
  SketchStateEnum,
  POPOUT_WINDOW_TITLE,
  TerminateReasonEnum,
  ErrorCode,
  IThemeOptions,
  GenesysWebMessagingAuthClient,
} from "../../models";
import {
  dispatchConversationStateChange,
  dispatchAgentChange,
  dispatchConversationTypeChange,
  dispatchCustomerChange,
  dispatchMessageReceived,
  dispatchMessageSent,
  dispatchConversationDataChange,
  dispatchConversationEnded,
  dispatchAgentTypingChange,
  dispatchMessageError,
  dispatchMemberSet,
  dispatchMemberRemove,
  dispatchConversationMinimizeChange,
} from "../../store/actions/conversation";
import {
  dispatchTicketChange,
  dispatchCallStateChange,
  dispatchCallEnded,
  dispatchAgentMuted,
  dispatchAgentVolumeChange,
  dispatchDisplayCaptureStateChange,
  dispatchDisplayCaptureError,
  dispatchTrackKindStateChange,
  dispatchScreenShareAvailabilityChange,
  dispatchCallPoppedOutChange,
  dispatchMediaAvailableChange,
  dispatchTestDevicePermissionsUrlChange,
  dispatchDisplayCaptureDirectionChange,
} from "../../store/actions";
import { RootState } from "../../store/states";
import { NotificationService } from "../../services/notification.service";
import {
  dispatchCobrowseStateChange,
  dispatchCobrowseOriginChange,
  dispatchCobrowseTicketChange,
  dispatchCobrowseRequestTypeChange,
} from "../../store/actions/cobrowse";
import {
  dispatchSketchEnded,
  dispatchSketchRequest,
} from "../../store/actions/sketch";
import { AVBusService } from "../../services/bus.service";
import {
  ThemeReadyAction,
  CustomerMetadataReadyAction,
  ToggleConversationPanelAction,
  SetCallQualityOptionsAction,
  CobrowseStartedAction,
  CoBrowseTerminatedAction,
} from "../../services/window.event.service";
import { HandledError } from "../../models/HandledError";
import {
  CobrowseFilterLayoutType,
  CobrowsePermissionEnum,
  DisplayCaptureDirectionEnum,
  KEY_AGENT_CONNECTED,
  KEY_GREETED,
  PARAM_MESSAGING,
} from "../../models/enums";
import { dispatchConversationRequestChange } from "../../store/actions/conversation";

import { KEY_CALL_ACCEPTED } from "../../models/enums";
import { NotificationTypeEnum } from "../../models/enums";
import { IMedia, ICallQualityOptions } from "../../models/IMedia";
import {
  ScheduleChannel,
  SchedulePicker,
} from "../../models/schedule/ISchedule";
import { ConversationAuthService } from "../../services/conversation.auth.service";

enum focusedElm {
  video,
  conversation,
}

interface IHomeState {
  expanded?: boolean;
  focusedElement?: focusedElm;
  chatOpen?: boolean;
  isGreetingOpen?: boolean;
  isCallbackOpen?: boolean;
  isLauncherOpen?: boolean;
  loading?: boolean;
  isCobrowseOpen?: boolean;
  isCreatingChat?: boolean;
  isTransfer?: boolean;
  isQueueVideoOpen?: boolean;
  isRequestingCall?: boolean;
  isTestingCaptcha?: boolean;
  isLoadingETQ?: boolean;
  secondsETQ?: number;
}

const DEFAULT_HOME_STATE: IHomeState = {
  expanded: false,
  focusedElement: focusedElm.conversation,
  chatOpen: false,
  isGreetingOpen: false,
  isCallbackOpen: false,
  isLauncherOpen: false,
  loading: false,
  isCobrowseOpen: false,
  isCreatingChat: false,
  isTransfer: false,
  isQueueVideoOpen: false,
  isRequestingCall: false,
  isTestingCaptcha: false,
  isLoadingETQ: false,
  secondsETQ: undefined,
};

const TRANSLATE_KEY_CHAT_NOTICE_VIDEO = "chat-notice";
const TRANSLATE_KEY_CHAT_NOTICE_AUDIO = "chat-notice-voice";
const TRANSLATE_KEY_CHAT_CUSTOMER_REJECTED = "chat-customer-rejected";
const CUSTOMER_CALL_ACCEPTED_ACK = "auvious:call:accepted";
const QUEUE_TIMEOUT_MESSAGE = "auvious:queue:timeout";
const CONVERSATION_ID_MESSAGE = "auvious:conversationId";

// const DEFAULT_CSS_VARIABLES = `
//   --av-border-radius-container: 10px;
//   --av-border-radius-button: 5px;
//   --av-font-family: Arial, Helvetica, sans-serif;
//   --av-font-size: 15px;
//   --av-font-color-dark: black;
//   --av-font-color-light: white;
//   --av-box-shadow-container: 0px 3px 10px -2px rgba(0, 0, 0, 0.2);
//   --av-background-color-tray: black;
//   --av-color-tray: white;
//   --av-color-primary: linear-gradient(150deg, #222b39 0%, black 100%);
//   --av-color-accent: #3366ff;
//   --av-color-danger: #fc3d61;
//   --av-color-success: #24d97f;
//   --av-box-shadow-confirm: 0 0 50px 450px rgba(0, 0, 0, 0.5);
// `;

@Component({
  tag: "app-auvious-widget",
  styleUrl: "app-home.scss",
  shadow: true,
  assetsDirs: ["assets"],
})
export class AppHome implements ComponentInterface {
  // required
  @Prop() pcEnvironment: string;

  @Prop() pcQueue: string; // Genesys Cloud specific
  @Prop() pcOrganizationId: string; // Genesys Cloud specific
  @Prop() pcDeploymentId: string; // Genesys Cloud specific
  @Prop() pcQueueId: string; // Genesys Cloud estimated wait time specific
  @Prop() pcWidgetScriptUrl: string; // Change the default genesy script url for chat-mode 'genesys-cloud' and 'genesys-premise'
  @Prop() pcWidgetPluginsPath: string; // Change the genesys plugins path, if a pcWidgetScriptUrl is set

  // required if callback enabled
  @Prop() applicationId: string;
  @Prop() applicationVerifySource: boolean = false;
  @Prop() pcCallbackQueue: string;
  @Prop() auviousEnvironment: string = "auvious.video";
  @Prop() auviousEventsEnvironment: string;
  @Prop() sentryDsn: string =
    "https://51e282ea2d0f4d3cb55d01a9f909c068@sentry.auvious.com/21";

  @Prop() dataUrl: string; // Genesys Engage (premise) specific (webchat short polling mode)
  @Prop() cometUrl: string; // Genesys Engage (premise) specific
  @Prop() cometChannel: string; // Genesys Engage (premise) specific
  @Prop() cometApiUrl: string; // Genesys Engage (premise) specific, for chat file upload/download support

  // NICE options
  @Prop() ncBrandId: number;
  @Prop() ncChannelId: string;
  @Prop() ncEnvironment: CXEnvironment;

  // VERINT options
  @Prop() vtServerUrl: string;
  @Prop() vtTenantId: string;

  // optional
  @Prop() registrationType: RegistrationTypeEnum = RegistrationTypeEnum.name;
  @Prop() customerAvatarUrl: string = Config.customerAvatar;
  @Prop() customerDisplayName: string;
  @Prop() customerSubject: string;
  @Prop() customerEmail: string;
  @Prop() customerId: string;
  @Prop() locale: string;
  @Prop() queueExtraSeconds: number = 30;
  @Prop() waitForGreetingSeconds: number = 3;
  @Prop() activeWidgets = WidgetsEnum.video; // string csv format. possible values : check WidgetsEnum
  @Prop() kioskMode: boolean = false;
  @Prop() organization: string = "Auvious";
  @Prop() chatMode: ChatModeEnum = "genesys-cloud";
  @Prop() queueMaxMinutes: number = 5;
  @Prop() queueEstimateWaitTime: boolean; // only for genesys
  @Prop() closeHidden = false;
  @Prop() popOutHidden = false;
  @Prop() incomingChatMessagesBlocked = false;
  @Prop() queueVideoUrl: string;
  @Prop() queueVideoDelaySeconds: number = 3;
  @Prop() launcherImageUrl: string;
  @Prop() confirmCall: boolean = false;
  @Prop() notificationSoundUrl: string;
  @Prop() greetingAction: WidgetsEnum;
  @Prop() greetingSoundOn: boolean;
  @Prop() schedule: ISchedule = {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    schedule: {},
  };
  @Prop() endedNotification: boolean = true;
  @Prop() testDevicePermissions = false;
  @Prop() customerDisplayNameBroadcast = false;
  @Prop() queueMessaging = false; // send messages while on queue
  @Prop() videoMessaging = false; // send messages while on a video call
  @Prop() chatAttachments = true; // attach files in chat (specific integrations)
  @Prop() chatNicknames = false; // show agent name / nickaname in chat
  @Prop() chatNotices = false; // show notices (currently participant joined  / left)
  @Prop() agentInfoHidden = false; // show agent name and avatar (whevener available)

  @Prop() scheduleMode: ScheduleChannel = "genesys-callback";
  @Prop() schedulePicker: SchedulePicker = "standard";
  @Prop() scheduleIntervalMinutes = 15;
  @Prop() scheduleOverlapCheck = false;
  @Prop() scheduleOverlapMaxConcurrent = 1;
  @Prop() scheduleDisclaimerUrl: string;
  @Prop() scheduleCustomerEmailRequired = true;

  @Prop() cobrowseDisclaimerUrl: string;
  @Prop() cobrowseDisplayCapture = false;
  @Prop() cobrowseIframeBlacklist: string[];

  // @deprecated
  @Prop() language: string;
  // @deprecated
  @Prop() timeslotIntervalMinutes: number;
  @Prop() captchaSiteKey: string; // not used for now

  // theme options
  @Prop() colorPrimary: string;
  @Prop() colorAccent: string;
  @Prop() colorWarn: string;
  @Prop() darkMode: boolean = false;
  @Prop() positionHorizontal: "left" | "right" | "center" = "right";
  @Prop() positionVertical: "top" | "bottom" = "bottom";
  @Prop() positionContainer: "fixed" | "custom" = "fixed";

  // heartbeat
  @Prop() interactionKeepAliveTimeoutSeconds: number = 0;

  // digital-connect
  @Prop() dcTouchpointId: string;
  @Prop() organizationId?: string; // currently required by talkdesk appointment overlap check

  @Element() hostRef;

  beforeLaunchAction: Function;
  launchRequest: { action: WidgetsEnum; ticket?: string };

  //config methods
  @Method()
  async setTranslations(map: ITranslationMap, language?: string) {
    ErrorHandler.addBreadcrumb("method:setTranslations");
    TranslateService.registerTranslation(language ?? Config.language, map);
  }

  @Method()
  async setTranslationFile(url: string, language: string) {
    try {
      ErrorHandler.addBreadcrumb("method:setTranslationFile");
      const validated = new URL(url);
      const translationMap: ITranslationMap = await ky
        .get(validated.toString())
        .json();
      TranslateService.registerTranslation(
        language ?? Config.language,
        translationMap
      );
    } catch (ex) {
      // not a valid url
      const error = new Error(
        `Auvious widget: Could not load translation. Reason: ${ex?.message}`
      );
      AVBusService.errorLog(
        new HandledError(error, ErrorCode.LOCALE_TRANSLATION_LOAD_FAILED)
      );
    }
  }

  @Method()
  async setCustomAssets(options: { assetPath: string; assets: string[] }) {
    ErrorHandler.addBreadcrumb("method:setCustomAssets");
    ThemeService.setCustomAssets(options);
  }

  @Method()
  async launch(action: WidgetsEnum, ticket?: string) {
    ErrorHandler.addBreadcrumb("method:launch", { action });
    if (!this.propsValid()) {
      console.error(
        "Auvious Widget invalid configuration. Cannot launch action."
      );
      return;
    }

    // conversation already exists. 'restorePreviousSession' will handle the reconnect

    if (
      this.$conversationState !== ConversationStateEnum.idle ||
      this.$conversationType
    ) {
      // keep the request in case the cType is a leftover from a previous call
      this.launchRequest = { action, ticket };
      return;
    }
    this.setViewState({ isLauncherOpen: true, expanded: true });
    let cType: ConversationTypeEnum;

    switch (action) {
      case WidgetsEnum.audio:
        cType = ConversationTypeEnum.voiceCall;
        break;
      case WidgetsEnum.video:
        cType = ConversationTypeEnum.videoCall;
        break;
      case WidgetsEnum.chat:
        cType = ConversationTypeEnum.chat;
        break;
      case WidgetsEnum.cobrowse:
        cType = ConversationTypeEnum.cobrowse;
        this.dispatchCobrowseRequestTypeChange("view");
        break;
      case WidgetsEnum.screenshare:
        cType = ConversationTypeEnum.cobrowse;
        this.dispatchCobrowseRequestTypeChange("display-capture");
        break;
      case WidgetsEnum.callback:
        cType = ConversationTypeEnum.callback;
        break;
    }
    this.dispatchConversationTypeChange(cType);
    this.tryCloseGreeting();
    this.handleLauncherAction(cType, ticket);
  }

  @Method()
  async terminate(confirm = true) {
    ErrorHandler.addBreadcrumb("method:terminate", { confirm });
    // do not terminate call if in the middle of testing or connecting
    if (
      [
        ConversationStateEnum.testing,
        ConversationStateEnum.testingDevicePermissions,
        ConversationStateEnum.connecting,
      ].includes(this.$conversationState)
    ) {
      this.isTerminationPending = { on: true, confirm };
      return;
    }
    AVBusService.terminateRequest(confirm);
  }

  @Method()
  async setCobrowseFilters(
    filters: string[],
    type: CobrowseFilterLayoutType = "darkBox"
  ) {
    ErrorHandler.addBreadcrumb("method:setCobrowseFilters");
    Config.cobrowseFilters = filters;
    Config.cobrowseFilterLayoutType = type;
  }

  @Method()
  /** allow to communicate with embedded documents from specific origins, allow all by default */
  async setAllowedOrigins(origins: string[]) {
    ErrorHandler.addBreadcrumb("method:setAllowedOrigins");
    Config.allowedOrigins = origins;
  }

  @Method()
  async setCobrowseIFrameOriginFilters(filters: string[]) {
    ErrorHandler.addBreadcrumb("method:setCobrowseIFrameOriginFilters");

    const isValidHttpUrl = (url: string): boolean => {
      const regex =
        /^https?:\/\/([a-zA-Z0-9.-]+|\d{1,3}(\.\d{1,3}){3})(:\d{1,5})?$/;
      return regex.test(url);
    };
    let valid = true;
    const invalidFilters = [];
    filters.forEach((item) => {
      const v = isValidHttpUrl(item);
      if (!v) {
        invalidFilters.push(item);
      }
      valid = valid && v;
    });
    if (valid) {
      Config.cobrowseIFrameOriginFilters = filters;
    } else {
      NotificationService.error("Invalid co-browse iFrame Origins", {
        body: `${invalidFilters.join(", ")} ${
          invalidFilters.length === 1 ? "is" : "are"
        } invalid. Use http(s)://domain[:port]`,
        ttl: -1,
      });
    }
  }

  @Method()
  async setQueueEmbeddableVideoCode(code: string) {
    ErrorHandler.addBreadcrumb("method:setQueueEmbeddableVideoCode");
    Config.updateOption({ queueEmbeddableVideoCode: code });
  }

  @Method()
  async setAuthenticatedSessionCode(token: string) {
    ErrorHandler.addBreadcrumb("method:setAuthenticatedSessionCode");
    if (
      Config.chatMode !== "genesys-web-messaging" &&
      Config.chatMode !== "cxone-dfo-chat"
    ) {
      console.warn(
        `Authenticated sessions for "${Config.chatMode}" chat mode are not supported.`
      );
    } else if (!ConversationFactory.instance) {
      console.warn(
        "Conversation is not enabled; ignoring authenticated session code."
      );
    } else {
      ConversationAuthService.setAuthenticatedSessionCode(token);
      // ConversationFactory.instance.useAuthenticatedSessionCode(token);
    }
  }

  @Method()
  async setCustomFields(customFields: ICustomField[]) {
    ErrorHandler.addBreadcrumb("method:setCustomFields");
    Config.updateOption({ customFields });
    const valid = Config.validateCustomFieldsFn();
    if (!valid) {
      this.dispatchConversationStateChange(ConversationStateEnum.error);
    }
  }

  @Method()
  async setCustomerMetadata(customerMetadata: { [key: string]: string }) {
    ErrorHandler.addBreadcrumb("method:setCustomerMetadata");
    if (customerMetadata.constructor === Object) {
      Config.updateOption({ customerMetadata });
    } else {
      NotificationService.error(
        "Invalid format for Customer metadata. Should be an object.",
        { errorCode: ErrorCode.REGISTRATION_INVALID_CUSTOMER_METADATA_FORMAT }
      );
      throw "invalid-customer-metadata-format";
    }
    // todo: autocomplete
  }

  @Method()
  async setAppointmentNotificationHeaders(appointmentNotificationHeaders: {
    [key: string]: string;
  }) {
    ErrorHandler.addBreadcrumb("method:setAppointmentNotificationHeaders");
    if (appointmentNotificationHeaders.constructor === Object) {
      Config.updateOption({ appointmentNotificationHeaders });
    } else {
      NotificationService.error(
        "Invalid format for appointment notification headers. Should be an object.",
        { errorCode: ErrorCode.REGISTRATION_INVALID_CUSTOMER_METADATA_FORMAT }
      );
      throw "invalid-appointment-notification-headers-format";
    }
  }

  @Method()
  public async setSchedule(schedule: ISchedule) {
    ErrorHandler.addBreadcrumb("method:setSchedule");
    Config.updateOption({ schedule });
  }

  /**
   * Ends the active conversation (chat) with an agent.
   * note: No need to clear the conversation. onEnded clears it.
   */
  @Method()
  public async endConversation() {
    ErrorHandler.addBreadcrumb("method:endConversation");
    Log.info("app-home: endConversation");
    if (this.$conversationState === ConversationStateEnum.idle) {
      this.conversationEnded.emit();
      return;
    }
    // this.dispatchCallStateChange(CallStateEnum.ended);
    this.dispatchConversationStateChange(ConversationStateEnum.leaving);
    try {
      await ConversationFactory.instance.endChat();
    } catch (error) {
      Log.debug("endChat error", error);
      AVBusService.errorLog(
        new HandledError(error, ErrorCode.CONVERSATION_END_FAILED)
      );
    }
    // clear storage after a while otherwise onLeaving the video card appears for 1-2 secs
    // since we have cleared the cached poppeOut property
    CommonService.timer.setTimeout(() => {
      this.clearSessionStorage();
    }, 3000);
  }

  @Method()
  public async playNotificationSound() {
    ErrorHandler.addBreadcrumb("method:playNotificationSound");
    Log.info("app-home: playNotificationSound");
    NotificationService.playNotificationSound();
  }

  @Method()
  public async setBeforeLaunchAction(action: Function) {
    ErrorHandler.addBreadcrumb("method:setBeforeLaunchAction");
    Log.info("app-home: setBeforeLaunchAction");
    this.beforeLaunchAction = action;
  }

  @Method()
  public async setCallQuality(quality: ICallQualityOptions) {
    ErrorHandler.addBreadcrumb("method:setVideoQuality");
    CallService.setQualityOptions(quality);
  }

  @Method()
  public async getRestoreState() {
    return await StorageService.getRestorableStateToString();
  }

  @Method()
  public async restoreState(state: string) {
    if (!state) return;
    await StorageService.restoreStateFromString(state);
    await this.restorePreviousSession();
    this.restoreCobrowseSession();
    this.restorePopup();
  }

  //events
  @Event() ready: EventEmitter<void>;

  @Event() callStarting: EventEmitter<void>;
  @Event() callStarted: EventEmitter<void>;
  @Event() callEnded: EventEmitter<{
    reason?: TerminateReasonEnum;
    error?: Error;
  }>;

  @Event() conversationStarted: EventEmitter<string>;
  @Event() conversationEnded: EventEmitter<void>;
  @Event() conversationDataChanged: EventEmitter<{ id: string }>;

  @Event() queueTimeChanged: EventEmitter<{ seconds: string; minutes: string }>;
  @Event() queueEstimatedWaitTimeChanged: EventEmitter<{ seconds: number }>;

  @Event() agentConnected: EventEmitter<string>;
  @Event() agentDisconnected: EventEmitter<void>;

  @Event() errorHandled: EventEmitter<object>;

  @Event() notificationOpened: EventEmitter<NotificationTypeEnum>;
  @Event() notificationClicked: EventEmitter<NotificationTypeEnum>;

  @Event() transfer: EventEmitter<string>;

  @Event() cobrowseConnecting: EventEmitter<void>;
  @Event() cobrowseConnected: EventEmitter<string>;
  @Event() cobrowseDisconnected: EventEmitter<void>;
  @Event() cobrowsePermissionsChanged: EventEmitter<{
    [key in CobrowsePermissionEnum]: boolean;
  }>;

  @State() state: IHomeState = { ...DEFAULT_HOME_STATE };
  @State() translations: { [key: string]: string };
  @State() themeOptions: IThemeOptions;

  @Watch("state")
  stateChange(nuValue: IHomeState, oldValue: IHomeState) {
    if (
      this.isCallStarted &&
      (nuValue.chatOpen !== oldValue.chatOpen ||
        nuValue.focusedElement !== oldValue.focusedElement)
    ) {
      WindowEventService.sendMessageToTarget(
        new ToggleConversationPanelAction(
          nuValue.focusedElement === focusedElm.conversation
        )
      );
    }
  }

  // store props
  @Prop({ mutable: true }) $conversationState: ConversationStateEnum;
  @Prop({ mutable: true }) $conversationType: ConversationTypeEnum;
  @Prop({ mutable: true }) $conversationAgent: IMember;
  @Prop({ mutable: true }) $messages: IMessage[];
  @Prop({ mutable: true }) $ticket: string;
  @Prop({ mutable: true }) $callState: CallStateEnum;
  @Prop({ mutable: true }) $deviceCaptureState: DisplayCaptureStateEnum;
  @Prop({ mutable: true }) $isRemoteScreenShareOn: boolean;
  @Prop({ mutable: true }) $isPoppedOut: boolean;
  @Watch("$isPoppedOut")
  poppedOutChange(value: boolean) {
    if (value && this.state.chatOpen) {
      this.setViewState({ focusedElement: focusedElm.conversation });
    }
  }
  @Prop({ mutable: true }) $cobrowseState: CobrowseStateEnum;
  @Prop({ mutable: true }) $cobrowseOrigin: CobrowseOriginEnum;
  @Prop({ mutable: true }) $sketchRoom: string;
  @Prop({ mutable: true }) $sketchState: SketchStateEnum;
  @Prop({ mutable: true }) $conversationData: IConversation;
  @Prop({ mutable: true }) $cobrowsePermissions: {
    [key in CobrowsePermissionEnum]: boolean;
  };
  @Watch("$cobrowsePermissions")
  permissionsChanged(value: { [key in CobrowsePermissionEnum]: boolean }) {
    this.cobrowsePermissionsChanged.emit(value);
  }
  @Prop({ mutable: true }) $mediaAvailable: IMedia;
  @Prop({ mutable: true }) $customerContactInfo: IContactInfo;
  @Prop({ mutable: true }) $members: { [id: string]: IMember };

  // store action dispatchers
  dispatchConversationStateChange: typeof dispatchConversationStateChange;
  dispatchConversationTypeChange: typeof dispatchConversationTypeChange;
  dispatchAgentChange: typeof dispatchAgentChange;
  dispatchMessageReceived: typeof dispatchMessageReceived;
  dispatchMessageSent: typeof dispatchMessageSent;
  dispatchConversationDataChange: typeof dispatchConversationDataChange;
  dispatchConversationEnded: typeof dispatchConversationEnded;
  dispatchTicketChange: typeof dispatchTicketChange;
  dispatchTestDevicePermissionsUrlChange: typeof dispatchTestDevicePermissionsUrlChange;
  dispatchCallStateChange: typeof dispatchCallStateChange;
  dispatchCallEnded: typeof dispatchCallEnded;
  dispatchAgentTypingChange: typeof dispatchAgentTypingChange;
  dispatchAgentMuted: typeof dispatchAgentMuted;
  dispatchAgentVolumeChange: typeof dispatchAgentVolumeChange;
  dispatchDeviceCaptureStateChange: typeof dispatchDisplayCaptureStateChange;
  dispatchDeviceCaptureError: typeof dispatchDisplayCaptureError;
  dispatchTrackKindStateChange: typeof dispatchTrackKindStateChange;
  dispatchScreenShareAvailabilityChange: typeof dispatchScreenShareAvailabilityChange;
  dispatchCallPoppedOutChange: typeof dispatchCallPoppedOutChange;
  dispatchCobrowseStateChange: typeof dispatchCobrowseStateChange;
  dispatchCobrowseOriginChange: typeof dispatchCobrowseOriginChange;
  dispatchSketchRequest: typeof dispatchSketchRequest;
  dispatchSketchEnded: typeof dispatchSketchEnded;
  dispatchCustomerChange: typeof dispatchCustomerChange;
  dispatchCobrowseTicketChange: typeof dispatchCobrowseTicketChange;
  dispatchConversationRequestChange: typeof dispatchConversationRequestChange;
  dispatchMediaAvailableChange: typeof dispatchMediaAvailableChange;
  dispatchMemberSet: typeof dispatchMemberSet;
  dispatchConversationMinimizeChange: typeof dispatchConversationMinimizeChange;
  dispatchMessageError: typeof dispatchMessageError;
  dispatchMemberRemove: typeof dispatchMemberRemove;
  dispatchCobrowseRequestTypeChange: typeof dispatchCobrowseRequestTypeChange;
  dispatchDisplayCaptureDirectionChange: typeof dispatchDisplayCaptureDirectionChange;

  private name: string;

  private subscription: Subscription = new Subscription();
  private frameSubscription: Subscription;
  private errorString: string;
  private leaveAfterAgentLeft;
  private isMobile: boolean;
  private disconnectedNotificationId: string;
  private greetingNotificationId: string;
  // private delayCreateChatMs: number = 0; // if we instantly start a chat before all the scripts are initialized, it fails, so we need to add a delay.
  private isWebMessagingWaitingForFeedback = false;
  private queueVideoTimeout: any;
  private reconnectTimeout: any;
  private queueMaxMinsTimeout: any;
  private disconnectedTimeout: any;
  private keepaliveInterval = 0;
  private greetingTimeout: any;
  private transferCheckTimeout: any;
  private cobrowseConnectTimeout: any;

  private $conversationReady = new Subject();
  private $componentReady = new Subject();
  private isTerminationPending = { on: false, confirm: false };
  private storeUnsubscribe: Unsubscribe;
  private isAgentNotAvailable = false;
  private roomTicket: string;
  private previousAgentId: string;
  // private cobrowseContainerRef: HTMLDivElement;

  private recaptcha: any;
  private launcherRef: HTMLAppLauncherElement;

  constructor() {
    ErrorHandler.init(this.sentryDsn);
    this.subscription.add(
      TranslateService.getTranslations().subscribe(
        (map) => (this.translations = map)
      )
    );
    this.isMobile = DeviceService.isMobile;
  }

  disconnectedCallback() {
    this.storeUnsubscribe();
    this.subscription.unsubscribe();
    ConversationAuthService.destroy();
  }

  async componentWillLoad() {
    this.loadCaptchaV3();

    // global/app.css is not bundled with the web-component so we need to inject
    ThemeService.injectCSSVariables();

    // setup store
    store.setStore(configureStore({}));
    store.mapStateToProps(this, (rootState: RootState) => {
      const {
        conversation: {
          state,
          type,
          messages,
          data,
          customerRequest,
          members,
          agent,
        },
        call: { ticket, isRemoteScreenShareOn, isPopedOut, mediaAvailable },
        sketch: { id },
        cobrowse: { origin, permissions },
      } = rootState;
      const cobrowseState = rootState.cobrowse.state;
      const sketchState = rootState.sketch.state;
      const deviceCaptureState = rootState.displayCapture.state;
      return {
        $conversationType: type,
        $conversationState: state,
        $conversationAgent: agent,
        $messages: messages,
        $conversationData: data,
        $ticket: ticket,
        $callState: rootState.call.state,
        $deviceCaptureState: deviceCaptureState,
        $isRemoteScreenShareOn: isRemoteScreenShareOn,
        $isPoppedOut: isPopedOut,
        $cobrowseState: cobrowseState,
        $cobrowseOrigin: origin,
        $sketchRoom: id,
        $sketchState: sketchState,
        $cobrowsePermissions: permissions,
        $mediaAvailable: mediaAvailable,
        $customerContactInfo: customerRequest,
        $members: members,
      };
    });
    store.mapDispatchToProps(this, {
      dispatchConversationStateChange,
      dispatchAgentChange,
      dispatchConversationTypeChange,
      dispatchMessageReceived,
      dispatchMessageSent,
      dispatchConversationDataChange,
      dispatchConversationEnded,
      dispatchTicketChange,
      dispatchCallStateChange,
      dispatchCallEnded,
      dispatchAgentTypingChange,
      dispatchAgentVolumeChange,
      dispatchAgentMuted,
      dispatchDeviceCaptureStateChange: dispatchDisplayCaptureStateChange,
      dispatchDeviceCaptureError: dispatchDisplayCaptureError,
      dispatchTrackKindStateChange,
      dispatchScreenShareAvailabilityChange,
      dispatchCallPoppedOutChange,
      dispatchCobrowseStateChange,
      dispatchCobrowseOriginChange,
      dispatchSketchRequest,
      dispatchSketchEnded,
      dispatchCustomerChange,
      dispatchCobrowseTicketChange,
      dispatchConversationRequestChange,
      dispatchMediaAvailableChange,
      dispatchTestDevicePermissionsUrlChange,
      dispatchMemberSet,
      dispatchConversationMinimizeChange,
      dispatchMessageError,
      dispatchMemberRemove,
      dispatchCobrowseRequestTypeChange,
      dispatchDisplayCaptureDirectionChange,
    });

    // store theme options
    ThemeService.setOptions(
      {
        darkMode: this.darkMode,
        colorPrimary: this.colorPrimary,
        colorAccent: this.colorAccent,
        colorWarn: this.colorWarn,
        positionHorizontal: this.positionHorizontal,
        positionVertical: this.positionVertical,
        positionContainer: this.positionContainer,
      },
      this.hostRef
    );

    // store config
    await Config.setOptions({
      customerDisplayName: this.customerDisplayName,
      customerId: this.customerId,
      customerEmail: this.customerEmail,
      customerSubject: this.customerSubject,
      customerAvatarUrl: this.customerAvatarUrl,
      applicationId: this.applicationId,
      pcQueue: this.pcQueue,
      pcEnvironment: this.pcEnvironment,
      pcDeploymentId: this.pcDeploymentId,
      pcOrganizationId: this.pcOrganizationId,
      pcCallbackQueueName: this.pcCallbackQueue,
      cxBrandId: +this.ncBrandId,
      cxChannelId: this.ncChannelId,
      cxEnvironment: this.ncEnvironment,
      vtServerUrl: this.vtServerUrl,
      vtTenantId: this.vtTenantId,
      pcWidgetScriptUrl: this.pcWidgetScriptUrl,
      pcWidgetPluginsPath: this.pcWidgetPluginsPath,
      auviousEnvironment:
        this.auviousEnvironment?.split("https://").length > 1
          ? this.auviousEnvironment.split("https://")[1]
          : this.auviousEnvironment,
      auviousEventsEnvironment: this.auviousEventsEnvironment,
      chatMode: this.chatMode,
      locale: this.locale || (this.language ? this.language + "-GR" : null), // support for deprecated language param
      kioskMode: this.kioskMode,
      organization: this.organization,
      dataUrl: this.dataUrl,
      cometUrl: this.cometUrl,
      cometChannel: this.cometChannel,
      cometApiUrl: this.cometApiUrl,
      closeHidden: this.closeHidden,
      popOutHidden: this.popOutHidden,
      incomingChatMessagesBlocked: this.incomingChatMessagesBlocked,
      queueVideoUrl: this.queueVideoUrl,
      queueVideoDelaySeconds: this.queueVideoDelaySeconds,
      customFields: [],
      launcherImageUrl: this.launcherImageUrl,
      confirmCall: this.confirmCall,
      greetingAction: this.greetingAction,
      greetingSoundOn: this.greetingSoundOn,
      notificationSoundUrl: this.notificationSoundUrl,
      schedule: this.schedule,
      captchaSiteKey: this.captchaSiteKey,
      scheduleMode: this.scheduleMode,
      schedulePicker: this.schedulePicker,
      dcTouchpointId: this.dcTouchpointId,
      registrationType: this.registrationType,
      // backwards compatibility for deprecated 'timeslotIntervalMinutes' prop
      scheduleIntervalMinutes:
        this.timeslotIntervalMinutes || this.scheduleIntervalMinutes,
      pcQueueId: this.pcQueueId,
      queueEstimateWaitTime: this.queueEstimateWaitTime,
      scheduleOverlapCheck: this.scheduleOverlapCheck,
      scheduleOverlapMaxConcurrent: this.scheduleOverlapMaxConcurrent,
      queueMessagingEnabled: this.queueMessaging,
      videoMessagingEnabled: this.videoMessaging,
      chatAttachmentsEnabled: this.chatAttachments,
      chatNicknamesEnabled: this.chatNicknames,
      chatNoticesEnabled: this.chatNotices,
      agentInfoEnabled: !this.agentInfoHidden,
      scheduleDisclaimerUrl: this.scheduleDisclaimerUrl,
      cobrowseDisclaimerUrl: this.cobrowseDisclaimerUrl,
      organizationId: this.organizationId,
      cobrowseDisplayCapture: this.cobrowseDisplayCapture,
      endedNotificationEnabled: this.endedNotification,
      scheduleCustomerEmailRequired: this.scheduleCustomerEmailRequired,
      applicationVerifySource: this.applicationVerifySource,
    });

    // trim spaces
    Config.setActiveWidgets(this.activeWidgets.replace(/ /g, ""));

    ThemeService.optionsAvailable().subscribe(
      (options) => (this.themeOptions = options)
    );

    await CommonService.initTimers();

    if (!this.propsValid()) {
      return;
    }

    await CommonService.createInstance();

    TranslateService.use(Config.language);

    this.subscription.add(
      NotificationService.clicked$.subscribe((notification) => {
        ErrorHandler.addBreadcrumb("notificationClicked");
        this.notificationClicked.emit(notification.type);
      })
    );

    this.subscription.add(
      NotificationService.opened$.subscribe((notification) => {
        ErrorHandler.addBreadcrumb("notificationOpened");
        this.notificationOpened.emit(notification.type);
      })
    );

    this.subscription.add(
      TranslateService.langChange$.subscribe(() => forceUpdate(this))
    );

    this.subscription.add(
      forkJoin([
        this.$componentReady.asObservable(),
        this.$conversationReady.asObservable(),
      ]).subscribe((_) => {
        this.ready.emit();
      })
    );

    if (Config.isConversationSupported) {
      await this.initConversationService();
      if (QueueService.supportsWaitTime()) {
        QueueService.init();
      }
    } else {
      this.$conversationReady.next();
      this.$conversationReady.complete();
    }

    if (Config.isScheduleSupported) {
      ScheduleService.init();
    }

    this.subscription.add(
      AVBusService.$error.subscribe((error) => {
        let logSentry = true;

        switch (error.code) {
          case ErrorCode.WEB_MESSAGING_AUTHENTICATION_FAILED:
            NotificationService.error("Authentication failed", {
              body: error.message,
            });
            this.setViewState({ loading: false, expanded: false });
            this.endConversation();
            this.dispatchConversationStateChange(ConversationStateEnum.error);
            logSentry = false;
            break;
          case ErrorCode.INIT_CHAT_SERVICE_FAILED:
            this.clearGreetingTimeout();
            this.dispatchConversationStateChange(ConversationStateEnum.error);
            NotificationService.error("Chat service could not start", {
              body: "Please refresh your page",
              ttl: -1,
            });
            break;
          case ErrorCode.COBROWSE_INVALID_PIN:
          case ErrorCode.COBROWSE_AUTHENTICATE_FAILED:
          case ErrorCode.SECURITY_APPLICATION_ID_MISMATCH:
            this.setViewState({
              loading: false,
              isCobrowseOpen:
                this.$cobrowseOrigin === CobrowseOriginEnum.widget,
            });
            break;
          case ErrorCode.COBROWSE_CONNECTION_FAILED:
            this.setViewState({ loading: false, isCobrowseOpen: false });
            break;
          // case ErrorCode.WEB_MESSAGING_FORBIDDEN:
          //   this.dispatchConversationStateChange(ConversationStateEnum.error);
          //   NotificationService.error("Chat service could not start", {
          //     body: "Please sign in to access this service",
          //     ttl: -1,
          //   });

          //   logSentry = false;
          //   break;
        }

        if (logSentry) {
          // Send error to Sentry
          ErrorHandler.captureError(error);
        }

        Log.error(error);

        this.errorHandled.emit({
          ...error.toObject(),
          breadcrumbs: ErrorHandler.getBreadcrumbs(),
        });
      })
    );
  }

  async componentDidLoad() {
    this.$componentReady.next();
    this.$componentReady.complete();

    try {
      const sessionRestoring = await this.restorePreviousSession();
      const cobrowseRestoring = this.restoreCobrowseSession();
      const popupRestoring = this.restorePopup();

      if (
        !this.isError &&
        this.isGreetingEnabled &&
        !sessionRestoring &&
        !cobrowseRestoring &&
        !popupRestoring &&
        !this.alreadyGreeted()
      ) {
        this.greet();
      }
    } catch (ex) {
      ErrorHandler.captureError(ex);
      if (this.isGreetingEnabled && !this.isError) {
        this.greet();
      }
    }
    if (DeviceService.isMobile) {
      ThemeService.calculateMobileViewportHeight();
      window.addEventListener("resize", (_) => {
        ThemeService.calculateMobileViewportHeight();
      });
    }
  }

  private propsValid(): boolean {
    const valid = Config.propsValid();

    if (window.location.protocol === "file:") {
      console.warn(
        "%c Auvious widget warning! %c",
        "font-size: 24px; color: orange;",
        ""
      );
      console.warn(
        "%c Please host this file in a server and use a valid SSL certificate.%c",
        "font-size: 18px; color: orange;",
        ""
      );
    }

    // doesn't make sense according to Epi
    // if (
    //   ![
    //     "auvious.video",
    //     "dev.auvious.video",
    //     "stg.auvious.video",
    //     "us.auvious.video",
    //     "au.auvious.video",
    //     "test.auvious.video",
    //     "premise.auvious.video",
    //     "genesys.auvious.com",
    //   ].includes(this.auviousEnvironment)
    // ) {
    //   console.warn(
    //     "Please check your auvious-environment unless you are using a custom domain"
    //   );
    // }

    this.dispatchConversationStateChange(
      valid ? ConversationStateEnum.idle : ConversationStateEnum.error
    );
    return valid;
  }

  /** focus only once at render */
  private autofocus(input: HTMLInputElement) {
    if (input && !input.hasAttribute("data-focused")) {
      requestAnimationFrame(() => {
        input.setAttribute("data-focused", "1");
        input.focus();
      });
    }
  }

  private greet() {
    this.greetingTimeout = CommonService.timer.setTimeout(() => {
      this.greetingNotificationId = NotificationService.greeting("Hi there!", {
        body: "How may we help you?",
        ttl: -1,
        sound: Config.getGreetingSoundOn(),
      });

      StorageService.setItem(KEY_GREETED, true, "session");

      this.subscription.add(
        NotificationService.clicked$
          .pipe(
            filter(
              (n) =>
                n.id === this.greetingNotificationId && !!this.greetingAction
            )
          )
          .subscribe(() => {
            let type: ConversationTypeEnum;
            switch (this.greetingAction) {
              case WidgetsEnum.audio:
                type = ConversationTypeEnum.voiceCall;
                break;
              case WidgetsEnum.video:
                type = ConversationTypeEnum.videoCall;
                break;
              case WidgetsEnum.cobrowse:
                type = ConversationTypeEnum.cobrowse;
                break;
              case WidgetsEnum.callback:
                type = ConversationTypeEnum.callback;
                break;
              case WidgetsEnum.chat:
                type = ConversationTypeEnum.chat;
                break;
            }
            if (!type) {
              return;
            }
            ErrorHandler.addBreadcrumb("Greeting action clicked", { type });
            this.dispatchConversationTypeChange(type);
            this.handleLauncherAction(type);
          })
      );
    }, this.waitForGreetingSeconds * 1000);
  }

  private async initConversationService() {
    // setup conversation handlers & create chat service
    const handlers: IConversationEventHandlers = {
      connecting: this.onConnecting.bind(this),
      connected: this.onConnected.bind(this),
      starting: this.onStarting.bind(this),
      started: this.onStarted.bind(this),
      ended: this.onEnded.bind(this),
      disconnected: this.onDisconnected.bind(this),
      reconnected: this.onReconnected.bind(this),
      agentNotified: this.onAgentNotified.bind(this),
      agentJoined: this.onAgentJoined.bind(this),
      agentLeft: this.onAgentLeft.bind(this),
      customerLeft: this.onCustomerLeft.bind(this),
      roomCreated: this.onRoomCreated.bind(this),
      messageReceived: this.onMessageReceived.bind(this),
      messageSent: this.onMessageSent.bind(this),
      agentTypingStarted: this.onAgentTypingStarted.bind(this),
      agentTypingStopped: this.onAgentTypingStopped.bind(this),
      cobrowseRequested: this.onCobrowseRequested.bind(this),
      error: this.onErrorCaptured.bind(this),
      ready: () => {
        this.$conversationReady.next();
        this.$conversationReady.complete();
      },
      messageError: (msg) => {
        ErrorHandler.addBreadcrumb(
          "Received message error from conversation service",
          { msg }
        );
        this.dispatchMessageError(msg);
      },
      memberRemoved: (member) => {
        ErrorHandler.addBreadcrumb("Conversation member removed", { member });
        this.dispatchMemberRemove(member);
      },
      memberSet: (member) => {
        if (
          member.id in this.$members &&
          (this.$members[member.id].displayName === member.displayName ||
            !member.displayName)
        ) {
          return;
        }
        ErrorHandler.addBreadcrumb("Conversation member added", { member });
        if (member?.role === "AGENT") {
          if (
            // the agent has answered the incoming interaction and has communicated
            // we don't know when the agent has connected in web messaging so we rely on this event
            this.chatMode === "genesys-web-messaging" &&
            this.isConversationChat
          ) {
            HeartbeatService.destroyMonitor();
          }
          this.dispatchAgentChange(member);
        }
        this.dispatchMemberSet(member);
      },
    };

    await ConversationAuthService.init();

    // create chat service based on config
    ConversationFactory.create(
      Config.optionsInstance(),
      handlers,
      ConversationAuthService.common,
      ConversationAuthService.client
    );

    // auto-fills ConversationFactory.instance.$conversation
    this.storeUnsubscribe = store.mapStateToProps(
      ConversationFactory.instance,
      (state: RootState) => {
        const {
          conversation: { data, members },
        } = state;
        return { $conversation: data, $members: members };
      }
    );
  }

  private alreadyGreeted(): boolean {
    const greeted = StorageService.getItem(KEY_GREETED, "session");
    return !!greeted;
  }

  private async restorePreviousSession(): Promise<boolean> {
    // restore cached data in case we refreshed
    const cType = StorageService.getItem(
      KEY_CONVERSATION_TYPE,
      "local"
    ) as ConversationTypeEnum;
    if (!!cType) {
      ErrorHandler.addBreadcrumb("trying to restore previous session");
      this.setViewState({ loading: true });
      this.dispatchConversationTypeChange(cType);

      this.clearGreetingTimeout();

      await Promise.race([
        this.$conversationReady.toPromise(),
        new Promise((_, reject) =>
          setTimeout(
            () =>
              reject(
                new Error("Conversation library has failed to load in time.")
              ),
            15000
          )
        ),
      ]);

      if (!Config.supportsCallReconnectOnRefresh) {
        const ticket = CallService.getStoredTicket();
        if (!!ticket) {
          ErrorHandler.addBreadcrumb("Stored ticket found, joining room", {
            ticket,
          });
          this.joinRoom(ticket);
        }
      }
      // try restore conv request
      try {
        const convReqStr = StorageService.getItem(
          KEY_CONVERSATION_REQUEST,
          "session"
        );
        if (convReqStr) {
          const convReq = JSON.parse(convReqStr) as IContactInfo;
          if (convReq) {
            this.dispatchConversationRequestChange(convReq);
            ErrorHandler.addBreadcrumb("Trying to reconnect to conversation", {
              convReq,
            });
            // try reconnect to session
            ConversationFactory.instance.reconnect(convReq, cType);
          }
        }
      } catch (ex) {
        Log.error("app-home: reconnect", ex);
      }

      // in case we somehow have a cType in localStorage but not an active connection, close after 5 secs.
      this.reconnectTimeout = CommonService.timer.setTimeout(() => {
        ErrorHandler.addBreadcrumb(
          "Reconnect to conversation timed out. Resetting"
        );
        this.setViewState({ loading: false });
        this.dispatchConversationTypeChange(null);
        StorageService.removeItem(KEY_CONVERSATION_TYPE, "local");

        if (this.launchRequest) {
          this.launch(this.launchRequest.action, this.launchRequest.ticket);
          this.launchRequest = undefined;
        }
      }, 5000);
      return true;
    }
    return false;
  }

  private restoreCobrowseSession(): boolean {
    // restore a co-browse session
    const ticket = CobrowseService.getStoredTicket();
    if (ticket) {
      ErrorHandler.addBreadcrumb("Co-browse ticket found. Restoring sesssion", {
        ticket,
      });
      !!this.greetingTimeout &&
        CommonService.timer.clearTimeout(this.greetingTimeout);
      this.setViewState({ loading: true });

      let origin: CobrowseOriginEnum;
      switch (this.$conversationType) {
        case ConversationTypeEnum.chat:
          origin = CobrowseOriginEnum.chat;
          break;
        case ConversationTypeEnum.videoCall:
        case ConversationTypeEnum.voiceCall:
          origin = CobrowseOriginEnum.iFrame;
          break;
        default:
          origin = CobrowseOriginEnum.widget;
          break;
      }

      const requestType = CobrowseService.getRequestType();

      this.dispatchCobrowseOriginChange(origin);
      this.dispatchCobrowseRequestTypeChange(requestType);
      this.dispatchCobrowseTicketChange(ticket);
      this.setViewState({ isCobrowseOpen: true });

      if (!this.$conversationType)
        this.dispatchConversationTypeChange(ConversationTypeEnum.cobrowse);

      return true;
    }
    return false;
  }

  private restorePopup(): boolean {
    // notify that we have a popped out panel in case we refresh
    const poppedOut = Boolean(
      StorageService.getItem(KEY_VIDEO_POPOUT, "session")
    );
    if (poppedOut) {
      ErrorHandler.addBreadcrumb(
        "Popped out video detected. Trying to reconnect"
      );
      // gain access to existing popup
      const popup = window.open("", POPOUT_WINDOW_TITLE);
      if (popup) {
        ErrorHandler.addBreadcrumb("Popped out video reconnected");
        WindowEventService.setPopOut(popup);
        this.dispatchCallPoppedOutChange(true);
        return true;
      } else {
        ErrorHandler.addBreadcrumb("Popped out video connection failed");
        StorageService.removeItem(KEY_VIDEO_POPOUT, "session");
        return false;
      }
    }
    return false;
  }

  private setViewState(props: IHomeState) {
    // Log.debug("** SET VIEW STATE ** ", this.state, props, Error().stack);
    this.state = { ...this.state, ...props };
  }

  private onWindowMessageReceived(action: Action) {
    if (!action) return;
    Log.info("app-home: window-message: ", action);
    ErrorHandler.addBreadcrumb("Received iFrame message from auvious", {
      action,
    });
    switch (action.type) {
      case windowActionType.READY:
        this.setThemeToIFrame();
        this.sendCallQualityOptionsToIFrame();
        break;
      case windowActionType.TRANSFER:
        this.transfer.emit(this.$conversationData.id);
        break;
      case windowActionType.CALL_ENDED:
        // action.payload : {reason?: TerminateReasonEnum, error?: Error}
        if (Config.kioskMode) {
          ThemeService.kioskCallEnded();
        }

        if (this.isConversationVisible) {
          this.dispatchConversationMinimizeChange(false);
        }

        // store ticket so that we don't use it on page refresh;
        CallService.setUsedTicket(
          SecurityService.extractTicketFromUrl(this.$ticket)
        );

        CallService.clearTicket();

        this.resetCall();
        if (this.$conversationState === ConversationStateEnum.onCall) {
          // having an ended call with an onCall conversation means we got transferred.
          // otherwise the conversation will have already ended
          this.dispatchCallStateChange(CallStateEnum.ended);
          this.dispatchConversationStateChange(
            action.payload?.reason === TerminateReasonEnum.transfer
              ? ConversationStateEnum.onQueue
              : ConversationStateEnum.agentConnected
          );
          // we fall back to chat
          if (
            action.payload?.reason !== TerminateReasonEnum.transfer &&
            (this.$messages.filter((m) => m.type !== "notice").length > 0 ||
              this.state.chatOpen ||
              !this.isVideoCardOpen)
          ) {
            this.dispatchConversationTypeChange(ConversationTypeEnum.chat);
            if (this.$messages.filter((m) => m.type !== "notice").length > 0) {
              this.setViewState({
                chatOpen: true,
                focusedElement: focusedElm.conversation,
              });
            } else {
              setTimeout(
                () => this.launcherRef?.focusAction(ConversationTypeEnum.close),
                200
              );
            }
          } else {
            setTimeout(
              () => this.launcherRef?.focusAction(ConversationTypeEnum.close),
              200
            );
          }
          this.setViewState({
            expanded: true,
            isTransfer: action.payload?.reason === TerminateReasonEnum.transfer,
          });

          if (action.payload?.reason === TerminateReasonEnum.transfer) {
            this.transfer.emit(this.$conversationData.id);
          }

          /*
          // having an ended call with an onCall conversation means the agent terminated the room
          // but kept the conversation open. open a chat to show something
          this.dispatchConversationStateChange(ConversationStateEnum.agentConnected);
          this.setViewState({
            chatOpen: true,
            focusedElement: focusedElm.conversation,
            expanded: false
          });
          */
        }
        if (action.payload?.reason !== TerminateReasonEnum.transfer) {
          this.callEnded.emit(action.payload);
        }
        this.clearWaitingTimer();

        if (this.$cobrowseState === CobrowseStateEnum.connected) {
          NotificationService.confirm(
            TranslateService.instant(
              "Call ended. Would you like to stop co-browsing as well?"
            ),
            { onApprove: this.endCobrowseRequest.bind(this) }
          );
        } else {
          NotificationService.announceVoiceOverMessage(
            TranslateService.instant("Call ended")
          );
        }

        break;
      case windowActionType.CALL_STARTED:
        this.dispatchCallStateChange(CallStateEnum.started);

        // stop heartbeat with auvious service
        HeartbeatService.destroyMonitor();

        if (
          Config.customerMetadata &&
          Object.keys(Config.customerMetadata).length > 0
        ) {
          // send customer metadata to iframe
          WindowEventService.sendMessageToTarget(
            new CustomerMetadataReadyAction(Config.customerMetadata)
          );
        }
        // sync chat state
        WindowEventService.sendMessageToTarget(
          new ToggleConversationPanelAction(
            this.state.chatOpen &&
              this.state.focusedElement === focusedElm.conversation
          )
        );
        const { audio, video, displayCapture } = action.payload;
        this.dispatchMediaAvailableChange({ audio, video, displayCapture });
        this.callStarted.emit();
        break;
      case windowActionType.CALL_ON_HOLD:
        this.dispatchCallStateChange(
          action.payload ? CallStateEnum.onHold : CallStateEnum.started
        );
        break;
      case windowActionType.FEEDBACK_REQUESTED:
        if (!this.$isPoppedOut) {
          // give some time to remove streams from the view
          this.dispatchCallStateChange(CallStateEnum.feedback);
        }
        this.setViewState({
          expanded: false,
          focusedElement: focusedElm.video,
        });
        break;
      case windowActionType.AGENT_MUTED:
        this.dispatchAgentMuted(action.payload);
        break;
      case windowActionType.AGENT_VOLUME_CHANGE:
        this.dispatchAgentVolumeChange(action.payload);
        break;
      case windowActionType.DEVICE_CAPTURE_ERROR:
        this.dispatchDeviceCaptureStateChange(DisplayCaptureStateEnum.error);
        this.dispatchDeviceCaptureError(action.payload);
        break;
      case windowActionType.DEVICE_CAPTURE_SUCCESS:
        this.dispatchDeviceCaptureStateChange(DisplayCaptureStateEnum.sharing);
        break;
      case windowActionType.DEVICE_CAPTURE_STOP_SUCCESS:
        this.dispatchDeviceCaptureStateChange(null);
        break;
      case windowActionType.MUTE_CHANGED:
        this.dispatchTrackKindStateChange(action.payload);
        break;
      case windowActionType.SCREEN_SHARE_AVAILABILITY_CHANGED:
        this.dispatchScreenShareAvailabilityChange(action.payload);
        this.dispatchDisplayCaptureDirectionChange(
          action.payload ? DisplayCaptureDirectionEnum.incoming : null
        );
        if (this.state.chatOpen) {
          action.payload || this.isRequestingFeedback || this.isOnVideoCall // if we have screen share, focus on that
            ? this.setViewState({ focusedElement: focusedElm.video })
            : this.setViewState({ focusedElement: focusedElm.conversation });
        }
        break;
      case windowActionType.COBROWSE_VIEW_REQUEST:
        // extract ticket from payload
        const { ticket, originator, requestType } = action.payload;
        if (!ticket) {
          return;
        }

        if (
          this.$cobrowseState === CobrowseStateEnum.connected &&
          !this.$cobrowsePermissions.view
        ) {
          // todo
        }

        // we are in a video / audio call and the remote agent requests a cobrowse session
        NotificationService.info(
          (requestType as CobrowseRequestType) === "display-capture"
            ? "Share screen"
            : "Co-browse",
          {
            body: "Initiating session...",
            ttl: 2000,
          }
        );

        // we need to know who started the co-browse session so as to send it back as IEndpointMetadata
        // on the agent side, in case more than one agents are available, only the one who requested the session
        // should continue with requesting view permission
        CobrowseService.setOriginator(originator);
        this.dispatchCobrowseOriginChange(CobrowseOriginEnum.iFrame);
        this.dispatchCobrowseRequestTypeChange(requestType || "view");
        this.dispatchCobrowseTicketChange(ticket);
        this.setViewState({ isCobrowseOpen: true });
        this.cobrowseConnectTimeout = CommonService.timer.setTimeout(() => {
          this.endCobrowseRequest();
        }, 10000);
        break;
      case windowActionType.COBROWSE_TERMINATE_REQUEST:
        if (this.state.isCobrowseOpen) {
          this.endCobrowseRequest();
        }
        break;
      case windowActionType.CONSENT_REQUEST:
        this.dispatchCallStateChange(CallStateEnum.consent);
        this.setViewState({ focusedElement: focusedElm.video });
        break;
      case windowActionType.CONSENT_RESPONSE:
        if (action.payload) {
          this.dispatchCallStateChange(CallStateEnum.starting);
          if (this.isConversationAudioCall && this.state.chatOpen) {
            this.setViewState({ focusedElement: focusedElm.conversation });
          }
        } else {
          // not accepted, revert to chat
          if (this.isConversationAudioCall) {
            this.dispatchConversationTypeChange(ConversationTypeEnum.chat);
          }
          ConversationFactory.instance.sendMessage(
            TranslateService.instant("Consent not given"),
            "notice"
          );
          HeartbeatService.destroyMonitor();
        }
        break;
      case windowActionType.RECORDER_STARTED:
        if (this.isConversationAudioCall) {
          NotificationService.info("Session is being recorded");
        }
        break;
      case windowActionType.RECORDER_ENDED:
        if (this.isConversationAudioCall) {
          NotificationService.info("Session is no longer recorded");
        }
        break;
      case windowActionType.CONVERSATION_PANEL_TOGGLE:
        this.setViewState({
          chatOpen: true,
          focusedElement: action.payload
            ? focusedElm.conversation
            : focusedElm.video,
        });
        this.dispatchConversationMinimizeChange(false);
        break;
    }
  }

  private registerLauncher(el) {
    this.launcherRef = el;
  }

  private setupHeartbeatMonitor() {
    if (this.interactionKeepAliveTimeoutSeconds > 0) {
      HeartbeatService.createMonitor(
        this.$conversationData,
        this.interactionKeepAliveTimeoutSeconds
      );
    }
  }

  private setupQueueEstimatedTimeMonitor(conversationId: string) {
    if (QueueService.supportsWaitTime()) {
      ErrorHandler.addBreadcrumb("Creating queue estimated time monitor", {
        conversationId,
      });
      this.setViewState({ isLoadingETQ: true });
      // this.subscription.add(
      QueueService.createEstimatedWaitTimeMonitor(
        {
          conversationId: conversationId,
        },
        (seconds) => {
          this.setViewState({ isLoadingETQ: false, secondsETQ: seconds });
          this.queueEstimatedWaitTimeChanged.emit({ seconds });
        },
        (error) => {
          ErrorHandler.addBreadcrumb(
            "Creating queue estimated time monitor failed",
            { error }
          );
          this.setViewState({
            isLoadingETQ: false,
            secondsETQ: undefined,
          });
          if (typeof error === "string" || error instanceof String) {
            if (error.includes("client not found")) {
              NotificationService.error("Bad configuration", {
                body: "You need to set a client id and client secret in auvious settings for the estimated time in queue to work.",
              });
            } else if (error.includes("remote status 400")) {
              NotificationService.error("Bad configuration", {
                body: "Please check your pc-queue-id or application-id for the estimated time in queue to work.",
              });
            }
          }
          AVBusService.errorLog(
            new HandledError(
              error,
              ErrorCode.CONVERSATION_ESTIMATE_WAIT_TIME_FAILED
            )
          );
        }
      );
      // );
    }
  }

  private keepAliveConversation() {
    if (
      [
        "genesys-cloud",
        "genesys-api",
        "genesys-web-messaging", // probably not needed but we keep it to be sure. tested and interaction kept alive after 15mins
        "genesys-premise",
      ].includes(Config.chatMode)
    ) {
      this.keepaliveInterval = CommonService.timer.setInterval(async () => {
        try {
          ErrorHandler.addBreadcrumb(
            "Keeping conversation alive by sending 'typing'"
          );
          await ConversationFactory.instance.sendTyping();
        } catch (ex) {
          ErrorHandler.log(
            new HandledError(ex, ErrorCode.CONVERSATION_TYPING_INDICATOR_FAILED)
          );
        }
      }, Config.keepConversationAliveInterval);
    }
  }

  private clearKeepAlive() {
    if (this.keepaliveInterval) {
      try {
        CommonService.timer.clearInterval(this.keepaliveInterval);
      } catch (ex) {
        ErrorHandler.captureError(ex);
      } finally {
        this.keepaliveInterval = 0;
      }
    }
  }

  private resetConversation() {
    ErrorHandler.addBreadcrumb("Conversation reset");
    // clear store
    this.dispatchConversationEnded();
    this.clearSessionStorage();
    HeartbeatService.cleanup();
    //
    this.clearKeepAlive();
    this.launchRequest = null;
    this.name = null;
    this.previousAgentId = null;
    if (!!this.leaveAfterAgentLeft) {
      CommonService.timer.clearTimeout(this.leaveAfterAgentLeft);
      this.leaveAfterAgentLeft = null;
    }

    if (this.testDevicePermissions) {
      this.dispatchTestDevicePermissionsUrlChange(null);
    }

    // EventsService.destroy();
    // should I destroy it? if the agent declines and then makes eligible, we receive the events.
    // if the user creates a second chat, he registers for the new chat events.
    // we are receiving events for both started calls.

    this.setViewState({ chatOpen: false, loading: false, isTransfer: false });
  }

  private resetCall() {
    ErrorHandler.addBreadcrumb("Call reset");
    this.clearKeepAlive();
    this.dispatchCallEnded();
    this.dispatchCallPoppedOutChange(false);
    this.frameSubscription?.unsubscribe();
    this.frameSubscription = null;
    WindowEventService.destroy();
  }

  private async testUserMedia(): Promise<boolean> {
    try {
      ErrorHandler.addBreadcrumb("Test media devices");
      const devices = await DeviceService.enumerateDevicesSafe();

      ErrorHandler.addBreadcrumb("Test media devices success");
      // we need at least a microphone to start a call
      return devices?.filter((d) => d.kind === "audioinput").length > 0;

      // const stream = await DeviceService.getUserMediaSafe({
      //   audio: true,
      //   video: !this.isConversationAudioCall,
      // });
      // if (!stream) {
      //   return false;
      // }
      // DeviceService.closeMediaStream(stream);
      // return true;
    } catch (ex) {
      ErrorHandler.addBreadcrumb("Test media devices failed", { ex });
      AVBusService.errorLog(
        new HandledError(ex, ErrorCode.MEDIA_DEVICES_GET_USER_MEDIA_FAILED)
      );
      return false;
    }
  }

  private notifyNoAgentAvailable() {
    this.isAgentNotAvailable = true;
    NotificationService.info("Please try again later", {
      body: "No agent seems to be available at the moment.",
      ttl: 50000,
    });
  }

  private setThemeToIFrame() {
    const doc = getComputedStyle(document.documentElement);
    // get css variables
    const cssVars = [
      "--av-border-radius-container",
      "--av-border-radius-button",
      "--av-font-family",
      "--av-font-family-monospace",
      "--av-font-family-serif",
      "--av-font-size",
      "--av-font-color-dark",
      "--av-font-color-light",
      "--av-box-shadow-container",
      "--av-color-primary",
      "--av-color-primary-contrast",
      "--av-color-accent",
      "--av-color-accent-dark",
      "--av-color-accent-contrast",
      "--av-color-danger",
      "--av-color-danger-contras",
      "--av-color-success",
      "--av-color-success-dark",
      "--av-color-success-contrast",
      "--av-color-warning",
      "--av-color-warning-contrast",
      "--av-color-focus-outline",
      "--av-color-info",
      "--av-color-info-contrast",
      "--av-color-black",
      "--av-color-white",
      "--av-link-color",
    ];
    let theme = {};
    cssVars.forEach((v) => {
      theme = {
        ...theme,
        [v]: doc.getPropertyValue(v),
      };
    });
    WindowEventService.sendMessageToTarget(new ThemeReadyAction(theme));
  }

  private sendCallQualityOptionsToIFrame() {
    if (CallService.getCallQualityOptions()) {
      WindowEventService.sendMessageToTarget(
        new SetCallQualityOptionsAction(CallService.getCallQualityOptions())
      );
    }
  }

  // ---- UI button handlers

  private tryCloseGreeting() {
    if (!!this.greetingTimeout) {
      CommonService.timer.clearTimeout(this.greetingTimeout);
      this.greetingTimeout = null;
    }
    if (this.greetingNotificationId) {
      this.closeGreeting();
    }
  }

  private closeGreeting() {
    NotificationService.dismiss(this.greetingNotificationId);
    this.greetingNotificationId = null;
  }

  private async start() {
    ErrorHandler.addBreadcrumb("Conversation flow start");

    if (!!this.greetingTimeout) {
      CommonService.timer.clearTimeout(this.greetingTimeout);
      this.greetingTimeout = null;
    }

    this.clearWaitingTimer();

    // clear any previous call data (ticket etc)
    this.dispatchCallPoppedOutChange(false);
    this.dispatchCallEnded();

    if (this.isConversationAudioVideoCall) {
      // test for getUserMedia
      this.setViewState({ expanded: true });
      this.dispatchConversationStateChange(ConversationStateEnum.testing);
      ErrorHandler.addBreadcrumb("Conversation test user media");
      const isMediaAvailable = await this.testUserMedia();
      if (!isMediaAvailable) {
        NotificationService.error("Media devices not available", {
          body: "Please check your permissions.",
          ttl: -1,
          errorCode: ErrorCode.MEDIA_DEVICES_NOT_AVAILABLE,
        });
        // this.setViewState({ expanded: false });
        // this.dispatchConversationStateChange(ConversationStateEnum.idle);
        // this.dispatchConversationTypeChange(null);
        AVBusService.terminateRequest(false);
        return;
      }

      // test for auvious core functinalities
      if (!DeviceService.isSupportedBrowser) {
        NotificationService.error("Not Supported browser", {
          body: "Please update or use a more modern browser",
          ttl: -1,
          errorCode: ErrorCode.BROWSER_NOT_SUPPORTED,
        });
        AVBusService.terminateRequest(false);
        return;
      }

      // if premature permission state is on, test it
      if (this.testDevicePermissions) {
        this.setViewState({ expanded: true });
        this.dispatchConversationStateChange(
          ConversationStateEnum.testingDevicePermissions
        );
        const testUrl = new URL(
          (Config.customDomainURL || Config.auviousBaseUrl) + "/permissions"
        );
        testUrl.searchParams.set(PARAM_WIDGET_ORIGIN_URL, window.origin);
        testUrl.searchParams.set(PARAM_CALL_TYPE, this.$conversationType);

        ErrorHandler.addBreadcrumb("Conversation test user media in url", {
          testUrl,
        });

        this.dispatchTestDevicePermissionsUrlChange(testUrl.toString());

        const deviceTest = new Promise((resolve, reject) => {
          this.frameSubscription = WindowEventService.reset(
            testUrl.toString()
          ).subscribe((action) => {
            if (!action) {
              return;
            }
            switch (action.type) {
              case windowActionType.TEST_DEVICE_PERMISSIONS_SUCCESS:
                resolve(true);
                break;
              case windowActionType.TEST_DEVICE_PERMISSIONS_ERROR:
                reject(action.payload);
                break;
              default:
                // what to do?
                resolve(true);
            }
          });
        });
        try {
          await deviceTest;
        } catch (ex) {
          const title = this.isConversationAudioCall
            ? "Microphone blocked"
            : "Camera & microphone blocked";
          const body = this.isConversationAudioCall
            ? "Please allow this page to access your microphone."
            : "Please allow this page to access your camera & microphone.";
          NotificationService.error(title, {
            body,
            ttl: -1,
            errorCode: ErrorCode.MEDIA_DEVICES_NOT_AVAILABLE,
          });
          // could not test devices. Reset everything and notify user
          NotificationService.error("Terminating conversation", {
            body: " Reason: " + ex.message,
            ttl: -1,
          });
          AVBusService.terminateRequest(false);
          return;
        }
      }

      // in case a user clicked on terminate while testUserMedia was await, cancel everything
      if (this.isTerminationPending.on) {
        this.isTerminationPending.on = false;
        AVBusService.terminateRequest(this.isTerminationPending.confirm);
        return;
      }
    }

    this.dispatchConversationRequestChange({
      firstName: this.customerDisplayName?.trim(),
      email: this.customerEmail,
      subject: this.customerSubject,
      ...Config.customerMetadata,
    });

    if (this.customerDisplayName?.trim()) {
      this.createChat({
        firstName: this.customerDisplayName.trim(),
        subject: this.customerSubject,
        email: this.customerEmail,
        id: this.customerId,
      });
      this.setViewState({ expanded: true });
      this.closeGreeting();
    } else {
      switch (this.registrationType) {
        case RegistrationTypeEnum.name:
          this.setViewState({ expanded: true });
          this.closeGreeting();
          this.dispatchConversationStateChange(
            ConversationStateEnum.registration
          );
          break;
        case RegistrationTypeEnum.nameEmailSubject:
        case RegistrationTypeEnum.custom:
          this.setViewState({ expanded: false });
          this.closeGreeting();
          this.dispatchConversationStateChange(
            ConversationStateEnum.registration
          );
          break;
      }
    }
  }

  private clearMaxMinsTimeout() {
    if (this.queueMaxMinsTimeout) {
      CommonService.timer.clearTimeout(this.queueMaxMinsTimeout);
      this.queueMaxMinsTimeout = null;
    }
  }

  private clearQueueVideoTimeout() {
    if (this.queueVideoTimeout) {
      CommonService.timer.clearTimeout(this.queueVideoTimeout);
      this.queueVideoTimeout = null;
    }
  }

  private clearReconnectTimeout() {
    if (this.reconnectTimeout) {
      CommonService.timer.clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }
  }

  private clearGreetingTimeout() {
    if (this.greetingTimeout) {
      CommonService.timer.clearTimeout(this.greetingTimeout);
      this.greetingTimeout = null;
    }
  }

  private clearCobrowseConnectTimeout() {
    if (this.cobrowseConnectTimeout) {
      CommonService.timer.clearTimeout(this.cobrowseConnectTimeout);
      this.cobrowseConnectTimeout = null;
    }
  }

  private launcherCloseRequest() {
    ErrorHandler.addBreadcrumb("Launcher action (X) clicked");
    this.clearMaxMinsTimeout();
    if (this.state.isRequestingCall) {
      this.setViewState({ isRequestingCall: false });
      StorageService.removeItem(KEY_CALL_ACCEPTED, "session");
    }
    if (
      this.isRegisteringName ||
      this.isRegisteringForm ||
      this.isTesting ||
      this.isTestingDevicePermissions ||
      this.isConnecting
    ) {
      this.setViewState({ expanded: false });
      this.dispatchConversationTypeChange(null);
      this.dispatchConversationStateChange(ConversationStateEnum.idle);
      this.dispatchTestDevicePermissionsUrlChange(null);
      this.conversationEnded.emit();
    } else if (this.isRegisteringCallback) {
      this.setViewState({ isCallbackOpen: false });
      this.dispatchConversationTypeChange(null);
    } else if (this.isConnected || this.isOnQueue) {
      this.clearSessionStorage();
      this.leaveQueue();
    } else if (this.isAgentConnected) {
      this.clearSessionStorage();
      if (!!this.$ticket) {
        // terminate call
        this.leaveCall(TerminateReasonEnum.leave);
      } else if (!this.$ticket) {
        if (this.isConversationAvailable) {
          this.endConversationRequest();
        }
      }
    } else if (this.isOnCall) {
      this.leaveCall(TerminateReasonEnum.leave);
      this.endConversation();
    }
    // terminate cobrowse irrelevant of flow
    if (this.state.isCobrowseOpen) {
      this.endCobrowseRequest();
    }
  }

  private clearSessionStorage() {
    StorageService.removeItem(KEY_CONVERSATION_TYPE, "local");
    StorageService.removeItem(KEY_VIDEO_POPOUT, "session");
    StorageService.removeItem(KEY_CALL_ACCEPTED, "session");
    StorageService.removeItem(KEY_AGENT_CONNECTED, "session");

    StorageService.removeItem(KEY_CONVERSATION_REQUEST, "session");

    CobrowseService.clearSessionStorage();
    CobrowseService.clearUsedTickets();

    this.clearWaitingTimer();
  }

  private clearWaitingTimer() {
    StorageService.removeItem(KEY_TIME_IN_QUEUE, "session");
  }

  private async launcherActionSelected(event: CustomEvent) {
    if (this.beforeLaunchAction != null) {
      await this.beforeLaunchAction(event.detail);
    }

    // store in case we refresh and we are still on queue
    this.dispatchConversationTypeChange(event.detail);
    this.handleLauncherAction(event.detail);
  }

  private handleLauncherAction(action: ConversationTypeEnum, ticket?: string) {
    ErrorHandler.addBreadcrumb("Laucher action clicked", { action });
    switch (action) {
      case ConversationTypeEnum.videoCall:
      case ConversationTypeEnum.voiceCall:
      case ConversationTypeEnum.chat:
        this.start();
        break;
      case ConversationTypeEnum.callback:
        this.setViewState({ isCallbackOpen: true });
        break;
      case ConversationTypeEnum.cobrowse:
        if (ticket) {
          // connect on the background
          this.dispatchCobrowseOriginChange(CobrowseOriginEnum.widget);
          this.dispatchCobrowseTicketChange(ticket);
          this.setViewState({ loading: true });
        }
        // open co-browse and it will either request for pin or use the provided ticket
        this.setViewState({ isCobrowseOpen: true });
        break;
    }
  }

  renderCaptchaV2(): Promise<void> {
    const recaptcha = window["grecaptcha"];
    const element = document.getElementById("captcha");
    return new Promise((resolve) => {
      recaptcha.render(element, {
        sitekey: "6LenI4ohAAAAAGYZk-yW_4bPg0i79AClfiKgabyi",
        callback: () => {
          element.innerHTML = "";
          resolve();
        },
        "expired-callback": () => {
          // todo
        },
      });
    });
  }

  loadCaptchaV3() {
    if (!this.captchaSiteKey) return;
    // create script
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js?render=" + this.captchaSiteKey
    );

    scriptElement.addEventListener("load", () => {
      this.recaptcha = window["grecaptcha"];
      this.recaptcha.ready(async () => {
        // hide the badge
        const el = document.querySelector(".grecaptcha-badge");
        if (!el) {
          NotificationService.error("Captcha failed to load", {
            body: "Please check your site-key",
          });
        } else {
          el.setAttribute("style", "visibility: hidden");
        }
      });
    });

    document.head.appendChild(scriptElement);
  }

  /**
   * https://stackoverflow.com/questions/44543157/how-to-hide-the-google-invisible-recaptcha-badge
   * @param cb
   */
  async testCaptchaV3(): Promise<boolean> {
    return new Promise(async (resolve) => {
      if (!this.captchaSiteKey || !this.recaptcha) {
        return resolve(true);
      }
      this.setViewState({ isTestingCaptcha: true });
      const token = await this.recaptcha.execute(
        "6Lc_bIkhAAAAABkV93joWkzLNme8yRkX2HGtYrJo",
        { action: "submit" }
      );

      // todo: need to verify it on the server side
      console.log(token);

      CommonService.timer.setTimeout(() => {
        this.setViewState({ isTestingCaptcha: false });
        resolve(false);
      }, 4000);
    });
  }

  private async customerDataReady(event: CustomEvent) {
    event.preventDefault();

    ErrorHandler.addBreadcrumb("Customer data ready");

    if (this.state.isCreatingChat) return;

    let contactInfo: IContactInfo = event.detail;

    if (this.isRegisteringName) {
      if (!this.name) {
        NotificationService.error("Required!", {
          errorCode: ErrorCode.REGISTRATION_REQUIRED_FIELD,
        });
        return;
      }
      contactInfo = { firstName: this.name };
    } else if (this.isRegisteringForm) {
      this.setViewState({ expanded: true });
    }

    /*
    // test captcha
    const isValidCaptcha = await this.testCaptchaV3();
    if (!isValidCaptcha) {
      NotificationService.error("reCAPTCHA test failed", {
        errorCode: ErrorCode.REGISTRATION_CAPTCHA_FAILED,
      });
      if (this.isRegisteringForm) {
        this.setViewState({ expanded: false });
      }
      return;
    }*/
    contactInfo = {
      id: this.customerId,
      ...Config.customerMetadata,
      ...this.$customerContactInfo,
      ...contactInfo,
    };
    this.dispatchConversationRequestChange(contactInfo);
    this.createChat(contactInfo);
  }

  private async createChat(contact: IContactInfo) {
    try {
      let updatedContact: IContactInfo = {
        ...contact,
        ...Config.customerMetadata,
      };
      updatedContact = {
        ...updatedContact,
        firstName: updatedContact.firstName?.trim(),
      };
      if (!updatedContact.firstName) {
        NotificationService.error("Required field", {
          body: "Please type a name to continue.",
        });
        return;
      }
      this.setViewState({
        isCreatingChat: true,
        loading: this.canSendMessagesWhileOnQueue,
      });

      let authCode;
      switch (Config.chatMode) {
        case "talkdesk-digital-connect":
          authCode = (
            ConversationAuthService.client as DigitalConnectAuthClient
          ).getAuthCode(updatedContact, this.$conversationType);
          break;
        case "genesys-web-messaging":
          authCode = (
            ConversationAuthService.client as GenesysWebMessagingAuthClient
          ).getAuthCode(ConversationAuthService.getAuthenticatedSessionCode());
          break;
        case "cxone-dfo-chat":
          authCode = {
            applicationId: Config.applicationId,
            code: Config.cxAuthorizationCode,
          };
          break;
      }

      ErrorHandler.addBreadcrumb("Conversation factory | create chat");
      await ConversationFactory.instance.createChat(
        updatedContact,
        this.$conversationType,
        authCode
      );
    } catch (ex) {
      ErrorHandler.addBreadcrumb("Conversation factory | create chat failed", {
        ex,
      });
      let body;
      switch (Config.chatMode) {
        case "genesys-api":
          body =
            TranslateService.instant(
              "Please verify the pcEnvironment, queue name, organization id and deployment id. Reason: "
            ) + ex.message;
          break;
        case "genesys-cloud":
        case "genesys-premise":
          if (ex.responseJSON?.code === "chat.error.invalid.queue") {
            body = ex.responseJSON?.message;
          } else {
            body =
              typeof ex == "string"
                ? ex
                : "Please verify the pcEnvironment, organization id and deployment id.";
          }
          break;
        case "genesys-web-messaging":
          break;
        case "talkdesk-digital-connect":
          switch (ex.code) {
            case ErrorCode.AUTHENTICATION_ERROR:
              switch (ex.status) {
                case 400:
                  body =
                    "Bad request. Please verify the application id, touchpoint id and other data.";
                  break;
                case 401:
                  body =
                    "Not authorized. Please check your talkdesk client id & secret in auvious settings and the customer email and subject.";
                  break;
                case 404:
                  body = "Not found";
                  break;
              }
              break;
            case ErrorCode.RTC_REGISTRATION_ERROR:
              break;
          }
          break;
        case "cxone-dfo-chat":
          switch (ex.code) {
            case ErrorCode.AUTHENTICATION_ERROR:
              body = "Chat is not available for unauthenticated users.";
              break;
          }
          break;
      }

      ErrorHandler.log(
        new HandledError(
          ex.responseJSON || ex,
          ErrorCode.CONVERSATION_START_FAILED
        )
      );

      NotificationService.error("Could not create a new interaction.", {
        body,
        ttl: -1,
      });

      this.setViewState({ loading: false });

      // another active chat session is probably on, do not reset view
      if (!!this.$conversationData) {
        if (this.$conversationState === ConversationStateEnum.connecting) {
          this.dispatchConversationStateChange(ConversationStateEnum.connected);
        }
        return;
      }

      this.setViewState({ expanded: false });
      this.dispatchConversationTypeChange(null);
      this.dispatchConversationStateChange(ConversationStateEnum.idle);
      this.clearSessionStorage();
    } finally {
      this.setViewState({ isCreatingChat: false });
      NotificationService.announceVoiceOverMessage(undefined);
    }
  }

  private handleNameChange(e) {
    this.name = e.target.value;
  }

  private getChatNoticeMessage() {
    const notice = this.isConversationAudioCall
      ? TRANSLATE_KEY_CHAT_NOTICE_AUDIO
      : TRANSLATE_KEY_CHAT_NOTICE_VIDEO;
    return TranslateService.instant(notice);
  }

  private getLanguageNoticeMessage() {
    return `${TranslateService.instant(
      "Customer's language is"
    )} ${TranslateService.instant(Config.language)}.`;
  }

  private getCustomerJoiningMessage() {
    return CUSTOMER_CALL_ACCEPTED_ACK;
  }

  private getCustomerNameMessage() {
    return `${TranslateService.instant("Customer's name is")} ${
      this.$customerContactInfo?.firstName
    }.`;
  }

  private async leaveQueue() {
    try {
      ErrorHandler.addBreadcrumb("Conversation factory | end chat");
      await ConversationFactory.instance.endChat();
    } catch (ex) {
      ErrorHandler.addBreadcrumb("Conversation factory | end chat failed", {
        ex,
      });
      AVBusService.errorLog(
        new HandledError(ex, ErrorCode.CONVERSATION_END_FAILED)
      );
      // clear everything in case endChat fails and we don't get the 'onEnded' event
      this.setViewState({ expanded: false, isQueueVideoOpen: false });
      this.dispatchConversationTypeChange(null);
      this.dispatchConversationStateChange(ConversationStateEnum.idle);
      this.dispatchCustomerChange(null);
      this.dispatchTestDevicePermissionsUrlChange(null);
      this.clearQueueVideoTimeout();
      CallService.clearUsedTickets();
      ConversationFactory.instance.destroy();
    }
  }

  /**
   * sets conversation state to 'leaving' and sends a leave action to iFrame.
   * we will wait for a CALL_ENDED to continue cleaning up the conversation.
   */
  private leaveCall(reason: TerminateReasonEnum) {
    ErrorHandler.addBreadcrumb("Leave call", { reason });
    this.setViewState({ focusedElement: focusedElm.video });
    try {
      //send message to iFrame to leave conference. on success, it will end the conversation.
      WindowEventService.sendMessageToTarget(new LeaveCallAction(reason));
    } catch (ex) {
      AVBusService.errorLog(
        new HandledError(ex, ErrorCode.CONVERSATION_URL_MISSING)
      );
      // we get an error if no Target is set. This may happen on a page refresh.
      this.endConversation();
    }
  }

  private focusChange(elm) {
    this.setViewState({ focusedElement: elm });
  }

  private async endConversationRequest() {
    ErrorHandler.addBreadcrumb("Conversation end request");
    if (!!this.$ticket) {
      // if we have an active call, just dismiss the chat card
      this.setViewState({ chatOpen: false });
      // we get a focusChange immediately after endConversationRequest originating from app-conversation:onClick
      // making the chat to focus again, so we need a timeout to really close the chat card.
      CommonService.timer.setTimeout(
        () => this.focusChange(focusedElm.video),
        100
      );
    } else {
      // otherwise end the conversation
      try {
        await ConversationFactory.instance.endChat();
      } catch (ex) {
        AVBusService.errorLog(
          new HandledError(ex, ErrorCode.CONVERSATION_END_FAILED)
        );
      }
    }
  }

  // private async startCobrowse(ticket) {
  // this.dispatchCobrowseStateChange(CobrowseStateEnum.connecting);
  // try {
  //   await CobrowseService.authenticate(ticket);
  //   this.setViewState({ isCobrowseOpen: true });
  // } catch (ex) {
  //   AVBusService.errorLog(
  //     new HandledError(ex, ErrorCode.COBROWSE_AUTHENTICATE_FAILED)
  //   );
  //   Log.error(ex); /* todo: how to handle? */
  // }
  //   this.dispatchCobrowseTicketChange(ticket);
  // }

  /**
   * termination coming from X (launcher)
   */
  private async endCobrowseRequest() {
    ErrorHandler.addBreadcrumb("Co-browse end request");
    let handled = false;
    switch (this.$cobrowseState) {
      case CobrowseStateEnum.idle:
        handled = true;
        this.dispatchConversationTypeChange(null);
        break;
      case CobrowseStateEnum.connected:
        handled = true;
        CobrowseService.terminate("user-terminated");
        break;
      case CobrowseStateEnum.ticketRequest:
        handled = true;
        this.dispatchConversationTypeChange(null);
        CobrowseService.resetStore();
        this.cobrowseDisconnected.emit();
        break;
      case CobrowseStateEnum.terminating:
        handled = true;
        Log.info("cobrowse: session is already being terminated");
        break;
      default:
        Log.error("cobrowse:endRequest state not handled");
        break;
    }
    if (handled) {
      this.setViewState({ isCobrowseOpen: false });
    }
  }

  private cobrowseTerminated() {
    ErrorHandler.addBreadcrumb("Co-browse terminated");
    if (this.$cobrowseState === CobrowseStateEnum.idle) {
      return;
    }
    if (this.$conversationType === ConversationTypeEnum.cobrowse) {
      this.dispatchConversationTypeChange(null);
      StorageService.removeItem(KEY_CONVERSATION_TYPE, "local");
    }
    this.setViewState({ isCobrowseOpen: false, loading: false });
    if (WindowEventService.isTargetAvailable) {
      WindowEventService.sendMessageToTarget(
        new ScreenShareAvailabilityChangedAction(true)
      );
      WindowEventService.sendMessageToTarget(new CoBrowseTerminatedAction());
    }
    this.cobrowseDisconnected.emit();
  }

  private cobrowseStarting() {
    ErrorHandler.addBreadcrumb("Co-browse starting");
    this.cobrowseConnecting.emit();
    this.clearCobrowseConnectTimeout();
    this.clearGreetingTimeout();
  }

  private cobrowseStarted(event) {
    ErrorHandler.addBreadcrumb("Co-browse started");
    this.setViewState({
      loading: false,
      isLauncherOpen: true,
      isCobrowseOpen: true,
    });
    if (WindowEventService.isTargetAvailable) {
      WindowEventService.sendMessageToTarget(
        new ScreenShareAvailabilityChangedAction(false)
      );
      WindowEventService.sendMessageToTarget(new CobrowseStartedAction());
    }

    this.clearReconnectTimeout();

    // store conversation type so that we can re-connect on refresh
    if (this.$conversationType === ConversationTypeEnum.cobrowse) {
      StorageService.setItem(
        KEY_CONVERSATION_TYPE,
        this.$conversationType,
        "local"
      );
    }

    this.cobrowseConnected.emit(event.detail);
  }

  private cobrowseConnectFailed() {
    ErrorHandler.addBreadcrumb("Co-browse connect failed");
    this.clearCobrowseConnectTimeout();
    this.setViewState({ loading: false, isCobrowseOpen: true });
  }

  // private cobrowseContainerReady(e: CustomEvent) {
  //   this.cobrowseContainerRef = e.detail as HTMLDivElement;
  // }

  // private getDisplayCaptureContainerOffsetX() {
  //   const offset = !!this.cobrowseContainerRef
  //     ? (this.isMobile
  //         ? this.cobrowseContainerRef.clientWidth + 40
  //         : this.cobrowseContainerRef.clientWidth - 10) + "px"
  //     : null;
  //   switch (this.themeOptions.positionHorizontal) {
  //     case "left":
  //       return { left: offset };
  //     case "right":
  //       return { right: offset };
  //   }
  // }

  private timerChanged(event: CustomEvent) {
    this.queueTimeChanged.emit(event.detail);
  }

  // ---- conversation event handlers

  private onConnecting() {
    Log.info("app-home: connecting");
    // this.dispatchConversationStateChange(ConversationStateEnum.connecting);
  }

  private async onConnected() {
    ErrorHandler.addBreadcrumb("Conversation | connected");
    Log.info("app-home: connected");
    // if we are coming from a reconnect on a websocket, check the customer state
    // https://developer.mypurecloud.ie/api/webchat/guestchat.html#reconnecting_the_guest
    const connected = await ConversationFactory.instance.customerConnected();
    if (!connected) {
      this.resetConversation();
      ConversationFactory.instance.destroy();
      return;
    }

    // cxone needs to send a message to the agent to start the chat
    if (Config.isCXOneDFO) {
      ConversationFactory.instance.sendMessage(
        this.getLanguageNoticeMessage(),
        "notice"
      );
    }

    // restored a previous session if onCall
    if (this.$conversationState !== ConversationStateEnum.onCall) {
      this.dispatchConversationStateChange(ConversationStateEnum.connected);
    }
    this.setViewState({ expanded: !this.canSendMessagesWhileOnQueue });
  }

  private onStarting() {
    ErrorHandler.addBreadcrumb("Conversation | starting");
    Log.info("app-home: starting");
    // todo: bad name for ConversationStateEnum.connecting.
    // it should be starting
    if (!this.isOnCall) {
      this.dispatchConversationStateChange(ConversationStateEnum.connecting);
    }
  }

  private onStarted(conversation: IConversation) {
    ErrorHandler.addBreadcrumb("Conversation | started");
    Log.info("app-home: onStarted", conversation);

    this.clearReconnectTimeout();

    // in case we have a reconnect from a new tab with existing interaction
    if (!this.$conversationType) {
      if (!this.state.loading) {
        this.setViewState({ loading: true });
      }
      // assume we have a chat conversation
      this.dispatchConversationTypeChange(ConversationTypeEnum.chat);
    }

    this.clearGreetingTimeout();

    // store conversation type so that we can re-connect on refresh
    if (
      [
        ConversationTypeEnum.voiceCall,
        ConversationTypeEnum.videoCall,
        ConversationTypeEnum.chat,
      ].includes(this.$conversationType) &&
      [
        "genesys-cloud",
        "genesys-premise",
        "genesys-web-messaging",
        "talkdesk-digital-connect",
        "cxone-dfo-chat",
        "verint-chat",
      ].includes(Config.chatMode)
    ) {
      StorageService.setItem(
        KEY_CONVERSATION_TYPE,
        this.$conversationType,
        "local"
      );
    }

    this.dispatchConversationDataChange(conversation);
    this.setViewState({ loading: false });

    // queue video
    if (
      !this.canSendMessagesWhileOnQueue &&
      this.queueVideoDelaySeconds > -1 &&
      !this.isAgentConnected &&
      (!!Config.queueEmbeddableVideoCode || !!Config.queueVideoUrl)
    ) {
      this.queueVideoTimeout = CommonService.timer.setTimeout(() => {
        this.setViewState({ isQueueVideoOpen: true });
      }, this.queueVideoDelaySeconds * 1000);
    }

    this.dispatchCustomerChange({
      displayName: this.name || this.customerDisplayName,
      role: "CUSTOMER",
      joinDate: new Date().toISOString(),
      id: null,
    });

    // set a timeout in case the agent never responds
    if (
      !this.canSendMessagesWhileOnQueue &&
      this.queueMaxMinutes > 0 &&
      this.$conversationType &&
      !this.isAgentConnected
    ) {
      this.queueMaxMinsTimeout = CommonService.timer.setTimeout(async () => {
        this.notifyNoAgentAvailable();
        this.clearMaxMinsTimeout();
        try {
          ErrorHandler.addBreadcrumb(
            "Conversation queueMaxMins timeout | agent not available | end chat"
          );
          await ConversationFactory.instance.endChat();
        } catch (ex) {
          AVBusService.errorLog(
            new HandledError(ex, ErrorCode.CONVERSATION_END_FAILED)
          );
        }
      }, this.queueMaxMinutes * 1000 * 60); //  make minutes to miliseconds
    }

    // if somehow the customer requested to terminate during 'testing' or 'connecting' state, close the newly created chat
    if (this.isTerminationPending.on) {
      this.isTerminationPending.on = false;
      AVBusService.terminateRequest(this.isTerminationPending.confirm);
    }

    if (!this.canSendMessagesWhileOnQueue) {
      // setup a heartbeat to monitor if the user closed the window
      if (
        this.$conversationData.id &&
        ((this.isConversationChat && !this.isAgentConnected) ||
          this.isConversationAudioVideoCall)
      ) {
        this.setupHeartbeatMonitor();
      }
      // setup time monitor
      this.setupQueueEstimatedTimeMonitor(conversation.id);
    } else {
      this.setViewState({ chatOpen: true, expanded: false });
    }

    this.conversationStarted.emit(conversation.id);
    if (conversation.id) {
      this.conversationDataChanged.emit({ id: conversation.id });
    }
  }

  private onDisconnected() {
    ErrorHandler.addBreadcrumb("Conversation | disconnected");
    Log.info("app-home: disconnected from websocket");
    if (this.isOnCall) {
      // wait for 5 seconds until we notify the user
      this.disconnectedTimeout = CommonService.timer.setTimeout(() => {
        this.disconnectedNotificationId = NotificationService.warning(
          "Connection lost",
          { body: "There seems to be an issue with the connection." }
        );
        // show message and clear timeout so in case we have a reconnect, we notify the user below
        this.disconnectedTimeout = null;
      }, 5000);
    }
  }

  private onReconnected() {
    ErrorHandler.addBreadcrumb("Conversation | reconnected");
    if (this.isOnCall) {
      if (!this.disconnectedTimeout && this.disconnectedNotificationId) {
        NotificationService.dismiss(this.disconnectedNotificationId);
        this.disconnectedNotificationId = null;
        // we have shown the user the connection lost message, notify that we re-connected.
        NotificationService.success("Connected", {
          body: "Connection restored",
        });
      } else {
        // we got a quick reconnect (below 5 secs), clear the timeout
        CommonService.timer.clearTimeout(this.disconnectedTimeout);
        this.disconnectedTimeout = null;
      }
    }
  }

  private async onAgentNotified() {
    ErrorHandler.addBreadcrumb("Conversation | agent notified");
    Log.info("app-home: agent-notified");
    if (!!this.leaveAfterAgentLeft) {
      Log.info(
        "app-home: on agent reconnected, clear timeout ",
        this.leaveAfterAgentLeft
      );
      CommonService.timer.clearTimeout(this.leaveAfterAgentLeft);
      this.leaveAfterAgentLeft = null;
    } else {
      try {
        const isRefresh = StorageService.getItem(
          KEY_AGENT_CONNECTED,
          "session"
        );
        if (!isRefresh) {
          if (!Config.pcAutoStartConversationEnabled && !Config.isCXOneDFO) {
            ConversationFactory.instance.sendMessage(
              this.getLanguageNoticeMessage(),
              "notice"
            );
          }
          if (this.isConversationAudioVideoCall) {
            ConversationFactory.instance.sendMessage(
              this.getChatNoticeMessage(),
              "notice"
            );
          }
          if (this.customerDisplayNameBroadcast) {
            ConversationFactory.instance.sendMessage(
              this.getCustomerNameMessage(),
              "notice"
            );
          }
        }
      } catch (ex) {
        ErrorHandler.captureError(
          new HandledError(ex, ErrorCode.CONVERSATION_MESSAGE_SEND_FAILED)
        );
      }
    }
    // in a restored session we instantly join the call
    if (this.$conversationState !== ConversationStateEnum.onCall) {
      this.dispatchConversationStateChange(ConversationStateEnum.onQueue);
    }
    this.setViewState({
      expanded: !this.canSendMessagesWhileOnQueue,
      chatOpen: this.canSendMessagesWhileOnQueue,
    });
  }

  private onAgentJoined(member: IMember) {
    ErrorHandler.addBreadcrumb("Conversation | agent joined");
    Log.info("app-home: onAgentJoined");
    this.agentConnected.emit(member.id);

    QueueService.destroyMonitor();

    if (this.$conversationType === ConversationTypeEnum.chat) {
      HeartbeatService.destroyMonitor();
    }

    // if we transfer to agent instead of queue, we get an agent disconnected and agent joined
    // event the moment the new agent answers the interaction. We need to clear the timeout
    // in case this happens
    if (this.transferCheckTimeout) {
      CommonService.timer.clearTimeout(this.transferCheckTimeout);
      this.transferCheckTimeout = undefined;
    }

    this.dispatchMemberSet(member);
    this.clearWaitingTimer();
    this.clearMaxMinsTimeout();
    this.clearQueueVideoTimeout();

    // coming from a page refresh, if we have an active conversation with genesys-premise or genesys-cloud
    // we get the message history. Open the chat in that case
    if (!this.$conversationType) {
      this.dispatchConversationTypeChange(ConversationTypeEnum.chat);
    }

    let nuState: IHomeState = {
      expanded: true,
      isTransfer: false,
      isQueueVideoOpen: false,
    };
    if (
      this.$conversationType === ConversationTypeEnum.chat ||
      this.$messages.filter((m) => m.type !== "notice").length > 0
    ) {
      nuState = {
        ...nuState,
        focusedElement: focusedElm.conversation,
        chatOpen: true,
        expanded: false,
      };
    }

    if (this.$conversationAgent) {
      // keep the previous agent, in case we have a transfer, we need to understand if the agent has changed
      this.previousAgentId = this.$conversationAgent.id;
    } else {
      StorageService.setItem(
        KEY_AGENT_CONNECTED,
        new Date().toISOString(),
        "session"
      );
      // an agent may invite a second agent to the chat. we only change the name if we have no other agents
      this.dispatchAgentChange(member);

      if (!this.isOnCall) {
        this.dispatchConversationStateChange(
          ConversationStateEnum.agentConnected
        );
      }
    }
    this.setViewState(nuState);
  }

  private async onRoomCreated(ticketUrl) {
    ErrorHandler.addBreadcrumb("Conversation | call created", { ticketUrl });
    const ticket = SecurityService.extractTicketFromUrl(ticketUrl);
    // reject any new ticket if are already in a call. Agent may have accidentaly sent it to chat.
    if (
      (!!this.$ticket && !this.$isPoppedOut) ||
      CallService.isTicketUsed(ticket)
    ) {
      return;
    }

    // if we escalate to video from a chat, we need to set it up, for the time range between here and room join.
    // it gets destroyed on call_started
    if (this.isConversationChat) {
      HeartbeatService.cleanup();
      this.setupHeartbeatMonitor();
    }

    this.clearMaxMinsTimeout();

    const url = new URL(ticketUrl);

    // this is an agent link, discard
    if (!!url.searchParams.get("aid")) {
      return;
    }

    try {
      await ConversationFactory.instance.sendMessage(
        this.getCustomerJoiningMessage(),
        "notice"
      );
    } catch (ex) {
      ErrorHandler.captureError(
        new HandledError(ex, ErrorCode.CONVERSATION_MESSAGE_SEND_FAILED)
      );
    }

    const alreadyAccepted = !!StorageService.getItem(
      KEY_CALL_ACCEPTED,
      "session"
    );
    if (this.confirmCall && !alreadyAccepted) {
      this.roomTicket = ticketUrl;

      ErrorHandler.addBreadcrumb("Conversation | call confirm");

      NotificationService.confirm(
        TranslateService.instant("Agent is requesting a call"),
        {
          onApprove: this.acceptCall.bind(this),
          onReject: this.denyCall.bind(this),
        }
      );

      this.setViewState({ isRequestingCall: true });
    } else {
      CallService.setTicket(ticketUrl);
      this.joinRoom(ticketUrl);
    }
  }

  private delay(millis: number): Promise<void> {
    return new Promise<void>((resolve) => {
      CommonService.timer.setTimeout(() => resolve(), millis);
    });
  }

  private acceptCall() {
    ErrorHandler.addBreadcrumb("Conversation | call accepted");
    this.setViewState({ isRequestingCall: false });
    StorageService.setItem(KEY_CALL_ACCEPTED, true, "session");
    CallService.setTicket(this.roomTicket);
    this.joinRoom(this.roomTicket);
    this.roomTicket = null;
  }

  private denyCall() {
    ErrorHandler.addBreadcrumb("Conversation | call denied");
    this.setViewState({ isRequestingCall: false });
    //Notify agent that customer rejected the call
    ConversationFactory.instance.sendMessage(
      TranslateService.instant(TRANSLATE_KEY_CHAT_CUSTOMER_REJECTED),
      "notice"
    );

    HeartbeatService.destroyMonitor();
  }

  private joinRoom(ticket: string) {
    ErrorHandler.addBreadcrumb("Call | join room");

    // start send 'typing' only when we join a room. We do not want
    this.keepAliveConversation();

    const url = new URL(ticket);

    // in case we come from a refresh, check the ticket found in messages
    // in case we are in a chat call, escalate to video / audio call
    if (!this.isConversationAudioVideoCall) {
      let type =
        (url.searchParams.get(PARAM_CALL_TYPE) as ConversationTypeEnum) ||
        ConversationTypeEnum.videoCall;
      if (type === ConversationTypeEnum.chat) {
        type = ConversationTypeEnum.videoCall;
      }
      this.dispatchConversationTypeChange(type);
    }

    switch (this.$conversationType) {
      case ConversationTypeEnum.videoCall:
        this.setViewState({
          focusedElement: focusedElm.video,
          expanded: false,
          chatOpen: this.$messages.length > 0,
        });
        break;
      case ConversationTypeEnum.chat:
        this.setViewState({
          focusedElement: this.$isPoppedOut
            ? focusedElm.conversation
            : focusedElm.video,
          expanded: false,
        });
        break;
      case ConversationTypeEnum.voiceCall:
        this.setViewState({
          focusedElement: this.state.chatOpen
            ? focusedElm.conversation
            : focusedElm.video,
          expanded: true,
        });
        break;
    }

    url.searchParams.set(PARAM_WIDGET_ORIGIN_URL, window.origin);
    url.searchParams.set(PARAM_CALL_TYPE, this.$conversationType);
    url.searchParams.set(PARAM_KIOSK_MODE, String(Config.kioskMode));
    url.searchParams.set(PARAM_LANG, Config.locale);
    url.searchParams.set(PARAM_COBROWSE_AVAILABLE, "true");
    url.searchParams.set(PARAM_MESSAGING, String(Config.videoMessagingEnabled));

    const name = this.name || this.customerDisplayName;
    if (name) {
      url.searchParams.set(PARAM_DISPLAY_NAME, name);
    }
    // if (DeviceService.isMobile && this.$conversationType === ConversationTypeEnum.videoCall) {
    //   const win = window.open(url.toString(), '_blank');
    //   win.focus();
    // } else {
    this.dispatchTicketChange(url.toString());
    // clear the testDevicePermissions after we get the ticket because the iFrame should not be hidden in iOS
    // otherwise the permissions will be requested again
    if (this.testDevicePermissions) {
      this.dispatchTestDevicePermissionsUrlChange(null);
    }
    // }
    this.dispatchCallStateChange(CallStateEnum.starting);

    // subscribe to iFrame events

    this.frameSubscription = WindowEventService.reset(ticket).subscribe(
      (action) => this.onWindowMessageReceived(action)
    );

    this.dispatchConversationStateChange(ConversationStateEnum.onCall);

    // if we are in a kiosk, we want the chat to be always on the bottom left
    if (Config.kioskMode) {
      ThemeService.kioskCallStarted();
      this.setViewState({ chatOpen: false });
    }
    this.dispatchConversationMinimizeChange(false);
    this.callStarting.emit();
  }

  private async onCobrowseRequested(
    ticket: string,
    type: CobrowseRequestType = "view"
  ) {
    ErrorHandler.addBreadcrumb("Co-browse requested");
    try {
      // check if ticket has already been used by a previous co-browse session
      if (
        CobrowseService.isTicketUsed(ticket) ||
        (this.$cobrowseState !== CobrowseStateEnum.idle &&
          this.$cobrowsePermissions.view) // we are connected but not accepted yet and we got a new invitation
      ) {
        return;
      }

      if (
        this.$cobrowseState === CobrowseStateEnum.connected &&
        !this.$cobrowsePermissions.view
      ) {
        ErrorHandler.addBreadcrumb("Co-browse previous session exists");
        // we got a new invitation while waiting to connect to the previous one
        // clear the previous and and try the new one
        await this.endCobrowseRequest();
        this.dispatchCobrowseTicketChange(null);
      }

      this.dispatchCobrowseRequestTypeChange(type);
      this.dispatchCobrowseOriginChange(CobrowseOriginEnum.chat);

      NotificationService.info(
        type === "display-capture" ? "Share screen" : "Co-browse",
        {
          body: "Initiating session...",
          ttl: 2000,
        }
      );

      // authenticate ticket
      this.dispatchCobrowseTicketChange(ticket);
      //
      this.setViewState({ isCobrowseOpen: true });
    } catch (ex) {
      AVBusService.errorLog(
        new HandledError(ex, ErrorCode.COBROWSE_AUTHENTICATE_FAILED)
      );
      // todo: what to do when cobrowse failed from chat?
    }
  }

  private getExcludedMessagesRules(): string[] {
    const rules = [
      TranslateService.instant(TRANSLATE_KEY_CHAT_NOTICE_VIDEO),
      TranslateService.instant(TRANSLATE_KEY_CHAT_NOTICE_AUDIO),
      TranslateService.instant(TRANSLATE_KEY_CHAT_CUSTOMER_REJECTED),
      this.getLanguageNoticeMessage(),
      this.getCustomerJoiningMessage(),
      QUEUE_TIMEOUT_MESSAGE,
      CONVERSATION_ID_MESSAGE,
    ];
    if (this.customerDisplayNameBroadcast) {
      rules.push(TranslateService.instant("Customer's name is"));
    }
    return rules;
  }

  private onMessageReceived(message: IMessage) {
    try {
      Log.info("app-home: message received", message);

      if (message.text?.includes(CONVERSATION_ID_MESSAGE)) {
        const data = message.text.split(":");
        const id = data.pop();
        this.dispatchConversationDataChange({
          ...this.$conversationData,
          id,
        });
        this.conversationDataChanged.emit({ id });

        if (!this.canSendMessagesWhileOnQueue) {
          this.setupHeartbeatMonitor();
        }
      }

      // check if the message is one our canned ones
      const rules = this.getExcludedMessagesRules();
      const isCanned = rules.some((rule) => message.text?.includes(rule));
      if (
        isCanned ||
        this.incomingChatMessagesBlocked ||
        this.$conversationState === ConversationStateEnum.idle ||
        (!AppConfigService.chatNoticesEnabled && message.type === "notice")
      ) {
        return;
      }

      this.dispatchMessageReceived(message);

      const expanded =
        this.isOnVoiceCall ||
        // we will receive a 'participant joined' message while on queue
        (this.isConversationAudioCall && AppConfigService.chatNoticesEnabled);
      this.setViewState({
        chatOpen: this.$messages.length > 0,
        focusedElement: focusedElm.conversation,
        expanded,
      });
      // the agent has closed the room, not the conversation and decices to send a message
      // we have assumed that we are on a transfer state
      if (
        this.isOnQueue &&
        (!AppConfigService.chatNoticesEnabled ||
          (AppConfigService.chatNoticesEnabled && message.type !== "notice"))
      ) {
        this.dispatchConversationStateChange(
          ConversationStateEnum.agentConnected
        );
        this.setViewState({ expanded: false });
      }
    } catch (ex) {
      ErrorHandler.captureMessage(["conversation.on.messageReceived"]);
      AVBusService.errorLog(
        new HandledError(ex, ErrorCode.CONVERSATION_MESSAGE_PARSE_FAILED)
      );
    }
  }

  private onMessageSent(message: IMessage) {
    const rules = this.getExcludedMessagesRules();
    const isCanned = rules.some((rule) => message.text?.includes(rule));
    if (isCanned) {
      return;
    }

    this.dispatchMessageSent(message);
  }

  private onAgentLeft(member?: IMember) {
    ErrorHandler.addBreadcrumb("Conversation | agent left");
    Log.info("app-home: agent left");
    if (this.isOnQueue) {
      this.leaveAfterAgentLeft = CommonService.timer.setTimeout(async () => {
        Log.info("app-home: agent left, resetting");
        try {
          ErrorHandler.addBreadcrumb(
            "Conversation | queue extra seconds timeout"
          );
          await ConversationFactory.instance.endChat();
        } catch (ex) {
          ErrorHandler.captureMessage(["conversation.on.agentLeft"]);
          AVBusService.errorLog(
            new HandledError(ex, ErrorCode.CONVERSATION_END_FAILED)
          );
        }
      }, this.queueExtraSeconds * 1000); // wait a bit more

      Log.info(
        "app-home: agent left, wait a bit more ",
        this.leaveAfterAgentLeft
      );
    } else {
      if (
        this.isConversationAudioVideoCall &&
        this.isOnCall &&
        (!this.isRequestingFeedback || this.isCallStarted)
      ) {
        if (this.isTicketAvailable) {
          // we need this to keep the video card open
          this.dispatchCallStateChange(CallStateEnum.ending);
        }
        // wait if we get a call-ended to understand if the agent left due to transfer or end
        /*
        setTimeout(() => {
          Log.info("app-home: agent left but still on call");
          // the agent has closed the chat interaction without closing the auvious app.
          // we need to leave from the room
          this.leaveCall(this.isOnCall);
        }, 1500);
        */
      } else if (
        this.isConversationChat ||
        (this.isConversationAudioVideoCall && !this.isOnCall)
      ) {
        // try to understand if we are transferred
        this.transferCheckTimeout = CommonService.timer.setTimeout(() => {
          if (
            this.isAgentConnected &&
            // we still haven't received the new agent
            this.$conversationAgent.id === this.previousAgentId
          ) {
            this.dispatchConversationStateChange(ConversationStateEnum.onQueue);
            this.setViewState({
              expanded: true,
              focusedElement: focusedElm.conversation,
              isTransfer: true,
            });

            this.transfer.emit(this.$conversationData.id);
          }
        }, 1500);
      }
    }
    if (member) {
      this.dispatchMemberRemove(member);
    }
    this.agentDisconnected.emit();
    // check if we have any remaining agents on the call. if yes, set them as the main agent
    const agent = Object.values(this.$members).find((m) => m.role === "AGENT");
    if (agent) {
      this.dispatchAgentChange(agent);
    }
  }

  private onCustomerLeft() {
    ErrorHandler.addBreadcrumb("Conversation | customer left");
    Log.info("app-home: customer left, waitToResetConversation");
    this.setViewState({ chatOpen: false });
    HeartbeatService.destroyMonitor();
    QueueService.destroyMonitor();
  }

  private async onEnded() {
    ErrorHandler.addBreadcrumb("Conversation | ended");
    Log.info("app-home: ended");
    if (
      this.isConversationAudioVideoCall &&
      this.isOnCall &&
      !this.isRequestingFeedback
    ) {
      if (this.kioskMode) {
        ThemeService.kioskCallEnded();
      }
      if (this.isConversationVisible) {
        this.dispatchConversationMinimizeChange(false);
      }
      this.leaveCall(TerminateReasonEnum.conversationEnded);
    }

    this.clearMaxMinsTimeout();

    if (this.$conversationState == ConversationStateEnum.idle) {
      return;
    }

    // we need to wait in case we get a rating request from the call
    if (this.chatMode === "genesys-web-messaging") {
      this.isWebMessagingWaitingForFeedback = true;
      await this.delay(500);
      this.isWebMessagingWaitingForFeedback = false;
    }

    const wasErrorState =
      this.$conversationState === ConversationStateEnum.error;

    this.dispatchConversationStateChange(ConversationStateEnum.idle);
    this.dispatchCustomerChange(null);
    this.setViewState({ expanded: false, isQueueVideoOpen: false });
    this.clearQueueVideoTimeout();
    this.resetConversation();
    CallService.clearUsedTickets();
    ConversationFactory.instance.destroy();

    if (
      Config.endedNotificationEnabled &&
      !this.isAgentNotAvailable &&
      !wasErrorState
    ) {
      NotificationService.info("Thank you for contacting us", {
        body: "We hope to see you again soon.",
      });
    }

    this.isAgentNotAvailable = false;

    if (this.state.isCobrowseOpen) {
      this.endCobrowseRequest();
    }

    this.conversationEnded.emit();
  }

  private onAgentTypingStarted() {
    this.dispatchAgentTypingChange(true);
  }

  private onAgentTypingStopped() {
    this.dispatchAgentTypingChange(false);
  }

  private onErrorCaptured(error) {
    ErrorHandler.addBreadcrumb("Conversation | error captured", { error });
    ErrorHandler.log(new HandledError(error, error.code));
  }

  // ---- View state getters

  private get canSendMessagesWhileOnQueue() {
    return Config.queueMessagingEnabled && this.isConversationChat;
  }

  get isRegisteringName() {
    return (
      this.$conversationState === ConversationStateEnum.registration &&
      this.registrationType === RegistrationTypeEnum.name
    );
  }
  get isRegisteringForm() {
    return (
      this.$conversationState === ConversationStateEnum.registration &&
      [
        RegistrationTypeEnum.nameEmailSubject,
        RegistrationTypeEnum.custom,
      ].includes(this.registrationType)
    );
  }
  get isConversationChat() {
    return this.$conversationType === ConversationTypeEnum.chat;
  }
  get isConversationAudioVideoCall() {
    return [
      ConversationTypeEnum.videoCall,
      ConversationTypeEnum.voiceCall,
    ].includes(this.$conversationType);
  }
  get isConversationVideoCall() {
    return this.$conversationType === ConversationTypeEnum.videoCall;
  }
  get isRegisteringCallback() {
    return this.state.isCallbackOpen;
  }
  get isInteracted() {
    return (
      this.$conversationType !== null &&
      !this.isRegisteringCallback &&
      !this.isRegisteringForm
    );
  }
  get isConnecting() {
    return this.$conversationState === ConversationStateEnum.connecting;
  }
  get isConnected() {
    return this.$conversationState === ConversationStateEnum.connected;
  }
  get isOnQueue() {
    return this.$conversationState === ConversationStateEnum.onQueue;
  }
  get isLeaving() {
    return this.$conversationState === ConversationStateEnum.leaving;
  }
  get isAgentConnected() {
    return this.$conversationState === ConversationStateEnum.agentConnected;
  }
  get isOnCall() {
    return (
      this.$conversationState === ConversationStateEnum.onCall &&
      !this.isCallEnded
    );
  }
  get isOnVideoCall() {
    return (
      this.isOnCall && this.$conversationType === ConversationTypeEnum.videoCall
    );
  }
  get isOnVoiceCall() {
    return (
      this.isOnCall && this.$conversationType === ConversationTypeEnum.voiceCall
    );
  }
  get isLoading() {
    return this.state.isTestingCaptcha || this.isConnecting || this.isTesting;
  }
  get isTesting() {
    return this.$conversationState === ConversationStateEnum.testing;
  }
  get isTestingDevicePermissions() {
    return (
      this.$conversationState === ConversationStateEnum.testingDevicePermissions
    );
  }
  get isError() {
    return this.$conversationState === ConversationStateEnum.error;
  }
  get isConversationAvailable() {
    return this.isOnQueue || this.isAgentConnected || this.isOnCall;
  }
  get isConversationVisible() {
    return (
      (this.isAgentConnected ||
        this.isOnCall ||
        this.canSendMessagesWhileOnQueue) &&
      this.state.chatOpen &&
      !this.isRequestingFeedback
    );
  }
  get isCoversationFocused() {
    return this.state.focusedElement === focusedElm.conversation;
  }
  get isVideoFocused() {
    return this.state.focusedElement === focusedElm.video;
  }
  get isCallbackEnabled() {
    return (
      [...Config.activeWidgets].includes(WidgetsEnum.callback) ||
      (!!this.greetingAction && this.greetingAction === WidgetsEnum.callback)
    );
  }
  get isCallEnded() {
    return this.$callState === CallStateEnum.ended;
  }
  get isConversationAudioCall() {
    return this.$conversationType === ConversationTypeEnum.voiceCall;
  }
  get isTicketAvailable() {
    return !!this.$ticket;
  }
  get isGreetingEnabled() {
    return this.waitForGreetingSeconds >= 0;
  }
  get isRequestingFeedback() {
    return this.$callState === CallStateEnum.feedback;
  }
  get isScreenSharing() {
    return this.$deviceCaptureState === DisplayCaptureStateEnum.sharing;
  }
  get isCallStarting() {
    return this.$callState === CallStateEnum.starting;
  }
  get isCallEnding() {
    return this.$callState === CallStateEnum.ending;
  }
  get isScreenShareOn() {
    return this.$isRemoteScreenShareOn;
  }
  get isSketchConnected() {
    return !!this.$sketchRoom;
  }
  get isCallTransfer() {
    return this.state.isTransfer;
  }
  get isCallStarted() {
    return this.$callState === CallStateEnum.started;
  }
  get isRequestingConsent() {
    return this.$callState === CallStateEnum.consent;
  }

  get cobrowseStateText() {
    switch (this.$cobrowseState) {
      case CobrowseStateEnum.connecting:
        return TranslateService.instant("Connecting...");
      case CobrowseStateEnum.connected:
        if (this.$cobrowsePermissions.control) {
          return TranslateService.instant("Agent is controlling your page");
        } else if (this.$cobrowsePermissions.view) {
          return TranslateService.instant("Agent is viewing your page");
        } else {
          return TranslateService.instant("Connecting...");
        }
      case CobrowseStateEnum.terminating:
        return TranslateService.instant("Closing...");
    }
  }

  get isVideoCardOpen(): boolean {
    return (
      this.isOnVideoCall ||
      (this.isCallEnding && !this.isConversationAudioCall) ||
      (this.isLeaving &&
        this.isConversationVideoCall &&
        this.isTicketAvailable) ||
      this.isRequestingFeedback ||
      this.isRequestingConsent ||
      this.isScreenShareOn
    );
  }

  // ---- View

  render() {
    const containerVisible =
      this.isInteracted &&
      !this.isRequestingFeedback &&
      (this.isError ||
        (this.isConnecting && this.state.expanded) ||
        this.isTesting ||
        this.isTestingDevicePermissions ||
        this.isRegisteringName ||
        this.isConnected ||
        this.isOnVoiceCall ||
        this.isConversationAudioCall ||
        // show while waiting in queue
        (this.isConversationAvailable &&
          !this.isConversationVisible &&
          !this.isOnVideoCall &&
          !this.isWebMessagingWaitingForFeedback));

    const containerClass = {
      "av-container": true,
      "av-container-visible": containerVisible && this.state.expanded,
      "av-container-expanded": containerVisible && this.state.expanded,
      "av-container-error": this.isError,
    };

    const buttonStyle = {
      backgroundColor: this.colorAccent,
    };

    let typeNameText = TranslateService.instant("type your name");

    const floatClass = {
      "av-floating": true,
      "av-floating-position-fixed":
        this.themeOptions?.positionContainer === "fixed",
      "av-floating-position-custom":
        this.themeOptions?.positionContainer === "custom",
      "av-floating-mobile": this.isMobile,
      "av-floating-left": this.themeOptions?.positionHorizontal === "left",
      "av-floating-center": this.themeOptions?.positionHorizontal === "center",
      "av-floating-right": this.themeOptions?.positionHorizontal === "right",
      "av-floating-bottom": this.themeOptions?.positionVertical === "bottom",
      "av-floating-top": this.themeOptions?.positionVertical === "top",
      "av-floating-offset": !this.closeHidden,
      // 'av-floating-middle': this.positionVertical === 'middle',
    };

    return (
      <Host>
        <div class={floatClass}>
          {this.state.isQueueVideoOpen && <app-media-player></app-media-player>}
          {this.isCallbackEnabled && this.state.isCallbackOpen && (
            <app-schedule
              onClose={() => this.setViewState({ isCallbackOpen: false })}
            ></app-schedule>
          )}

          {/* {false && <app-callback-timeslots></app-callback-timeslots>} */}
          <av-notification-manager
            offset={containerVisible}
          ></av-notification-manager>

          {[
            RegistrationTypeEnum.nameEmailSubject,
            RegistrationTypeEnum.custom,
          ].includes(this.registrationType) &&
            this.isRegisteringForm && (
              <app-customer
                loading={this.state.isTestingCaptcha}
                registrationType={this.registrationType}
                onCompleted={this.customerDataReady.bind(this)}
              ></app-customer>
            )}

          {this.isSketchConnected && (
            <app-sketch room={this.$sketchRoom}></app-sketch>
          )}

          {this.state.isCobrowseOpen && (
            <app-cobrowse
              onStarting={this.cobrowseStarting.bind(this)}
              onStarted={this.cobrowseStarted.bind(this)}
              onConnectFailed={this.cobrowseConnectFailed.bind(this)}
              onTerminated={this.cobrowseTerminated.bind(this)}
            ></app-cobrowse>
            // onContainerReady={this.cobrowseContainerReady.bind(this)}
          )}

          {this.isConversationVisible && (
            <app-conversation
              onClick={() => this.focusChange(focusedElm.conversation)}
              focused={this.isCoversationFocused}
            ></app-conversation>
          )}

          <div class={containerClass}>
            {this.state.expanded && [
              <div>
                {!!Config.captchaSiteKey && (
                  <av-card open={true} inline={true} class="captcha">
                    <div slot="card-body" class="captcha-body">
                      <av-captcha-disclaimer></av-captcha-disclaimer>
                    </div>
                  </av-card>
                )}
              </div>,
              <div class="generic-container" aria-live="polite">
                {this.isRegisteringName && !this.state.isTestingCaptcha && (
                  <form
                    class="input-container"
                    onSubmit={this.customerDataReady.bind(this)}
                  >
                    <input
                      placeholder={typeNameText}
                      type="text"
                      data-tid="home/customer-name"
                      onInput={this.handleNameChange.bind(this)}
                      ref={(elm) => this.autofocus(elm)}
                    />
                    <button
                      aria-label={TranslateService.instant("Start call")}
                      class="btn-round"
                      style={buttonStyle}
                      type="submit"
                    >
                      {this.$conversationType === ConversationTypeEnum.chat && (
                        <av-asset image="chat"></av-asset>
                      )}
                      {this.$conversationType ===
                        ConversationTypeEnum.videoCall && (
                        <av-asset image="cam"></av-asset>
                      )}
                      {this.$conversationType ===
                        ConversationTypeEnum.voiceCall && (
                        <av-asset image="mic"></av-asset>
                      )}
                    </button>
                    {/* <av-button onClick={this.customerDataReady.bind(this)} shape="round" color="accent">
                      {this.$conversationType === ConversationTypeEnum.chat &&
                        <av-asset image="chat"></av-asset>
                      }
                      {this.$conversationType === ConversationTypeEnum.videoCall &&
                        <av-asset image="cam"></av-asset>
                      }
                      {this.$conversationType === ConversationTypeEnum.voiceCall &&
                        <av-asset image="mic"></av-asset>
                      }
                    </av-button> */}
                  </form>
                )}
                {this.state.isTestingCaptcha && (
                  <div class="text-container">
                    <av-translate>Testing reCAPTCHA...</av-translate>
                  </div>
                )}
                {(this.isTesting || this.isTestingDevicePermissions) && (
                  <div class="text-container" data-tid="home/checking-devices">
                    <av-translate>Checking devices...</av-translate>
                  </div>
                )}
                {this.isConnecting && (
                  <div class="text-container" data-tid="home/connecting">
                    <av-translate>Connecting...</av-translate>
                  </div>
                )}
                {(this.isConnected || this.isOnQueue) && (
                  <div class="text-container">
                    {this.isCallTransfer && (
                      <div data-tid="home/transfer-start">
                        <av-translate>Transferring...</av-translate>
                      </div>
                    )}
                    {!this.isCallTransfer && (
                      <div data-tid="home/transfer-on-queue">
                        <av-translate>Finding a representative...</av-translate>
                      </div>
                    )}
                    {this.isOnQueue &&
                      !this.state.isLoadingETQ &&
                      this.state.secondsETQ == undefined && (
                        <av-timer
                          onChanged={this.timerChanged.bind(this)}
                        ></av-timer>
                      )}
                    {this.isOnQueue &&
                      !this.state.isLoadingETQ &&
                      this.state.secondsETQ > 0 && (
                        <div class="tooltip-container">
                          <b class="blink estimated-wait-time">
                            ~ {this.state.secondsETQ}s
                          </b>
                          <span class="tooltip">
                            <av-translate>
                              Estimated wait time in queue
                            </av-translate>
                          </span>
                        </div>
                      )}

                    {/* {this.isOnQueue && this.state.isLoadingETQ && (
                      <av-spinner isTray={true}></av-spinner>
                    )} */}
                  </div>
                )}
                {this.isAgentConnected && (
                  <div
                    class={{
                      "avatar-container": true,
                      "avatar-container-mobile": DeviceService.isMobile,
                    }}
                    data-tid="home/agent-connected"
                  >
                    <av-agent>
                      {this.$messages.filter((m) => m.type !== "notice")
                        .length === 0 &&
                        !this.state.isCobrowseOpen && (
                          <av-translate>Please wait...</av-translate>
                        )}
                      {this.$messages.length === 0 &&
                        this.state.isCobrowseOpen && (
                          <span data-tid="home/cobrowse-state">
                            {this.cobrowseStateText}
                          </span>
                        )}
                    </av-agent>
                    <av-status></av-status>
                  </div>
                )}
                {this.isOnVoiceCall && <app-voice-call></app-voice-call>}
                {this.isError && this.errorString && (
                  <div class="text-container" data-tid="home/error">
                    <small>{this.errorString}</small>
                  </div>
                )}

                {(this.isLoading ||
                  (this.isOnQueue && this.state.isLoadingETQ)) && (
                  <div
                    class={{
                      "spinner-container": true,
                      "spinner-container-inverted":
                        this.themeOptions.direction === "rtl",
                    }}
                    data-tid="home/loading"
                  >
                    <av-spinner isTray={true}></av-spinner>
                  </div>
                )}
              </div>,
            ]}
          </div>

          <app-video-call
            open={this.isVideoCardOpen}
            focused={this.state.focusedElement === focusedElm.video}
            onFocusChange={() => this.focusChange(focusedElm.video)}
          ></app-video-call>

          {(!Config.kioskMode || (Config.kioskMode && !this.isVideoCardOpen)) &&
            (!this.isError ||
              (this.isError &&
                this.registrationType === RegistrationTypeEnum.name &&
                !!this.$conversationType)) && (
              <app-launcher
                loading={this.state.loading}
                widgets={Config.activeWidgets}
                ref={this.registerLauncher.bind(this)}
                onToggled={this.tryCloseGreeting.bind(this)}
                onCloseRequest={this.launcherCloseRequest.bind(this)}
                onActionSelected={this.launcherActionSelected.bind(this)}
              ></app-launcher>
            )}
        </div>
      </Host>
    );
  }
}
